/*
SLB GENERATED FILE — DO NOT EDIT
Project: Saam Law BaseStation (SLB)
Build-Version: SLB_V4_133_JEE_CHAT_TRANSACTION_CONSOLE_20260910_01
Output: assets/slb.library.js
Source: slb_src/slices/library/
Build: slb_build/build_library.mjs
Built: 2026-09-19 16:53:57.833Z
Content-SHA256: e28110e55b027b06a0e2eaa4832ecc2126ac61dc488ff55118ac24516df7f0ff
Content-SHA256-12: e28110e55b02
*/

/* MIGRATED SOURCE
   Original asset: /assets/slb.library.js
   Note: This file was copied as-is to bring the module under the slice build pipeline.
   Safe refactor can be done later by splitting into multiple numbered parts.
*/

/* SLB Library (Records → Library)
 * - Everyone can post/read
 * - Moderator can delete others (but not admin's posts/comments)
 * - Admin can manage categories + groups + delete anyone
 *
 * Backend actions:
 * - libraryBootstrap, libraryList, libraryGet
 * - libraryPostUpsert, libraryPostDelete, libraryCommentAdd, libraryCommentDelete
 * - adminLibraryCatsUpsert, adminLibraryCatsDelete
 * - adminLibraryGroupsGet, adminLibraryGroupsUpsert, adminLibraryGroupsDelete
 */
(function(){
  const $ = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  const CSS_ESCAPE = (window.CSS && CSS.escape) ? CSS.escape : function(s){
    return String(s||"").replace(/[^a-zA-Z0-9_-]/g, function(ch){ return "\\" + ch; });
  };

  function esc(s){
    return String(s||"")
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  // ===== Rich HTML sanitizer (client-side; server sanitizes too) =====
  const RICH_ALLOWED_TAGS = new Set([
    'B','STRONG','I','EM','U','S','DEL','STRIKE','BR','P','DIV','SPAN',
    'UL','OL','LI','BLOCKQUOTE','H1','H2','H3','H4',
    'A','IMG','IFRAME'
  ]);
  const RICH_ALLOWED_ATTRS = {
    'A': new Set(['href','target','rel','title']),
    'IMG': new Set(['src','alt','title','width','height','loading']),
    'SPAN': new Set(['style']),
    'DIV': new Set(['style','class']),
    'P': new Set(['style']),
    'H1': new Set(['style']),
    'H2': new Set(['style']),
    'H3': new Set(['style']),
    'H4': new Set(['style']),
    'IFRAME': new Set(['src','width','height','title','allow','allowfullscreen','frameborder','loading','referrerpolicy','class'])
  };

  function safeUrl(u){
    u = String(u||'').trim();
    if(!u) return '';
    const low = u.toLowerCase();
    if(low.startsWith('javascript:') || low.startsWith('data:') || low.startsWith('vbscript:')) return '';
    if(low.startsWith('http://') || low.startsWith('https://')) return u;
    return '';
  }
  function sanitizeStyle(style){
    style = String(style||'').trim();
    if(!style) return '';
    const allow = new Set(['color','background-color','font-size','text-decoration','font-weight','font-style','text-align']);
    const out = [];
    style.split(';').forEach(pair => {
      const p = pair.split(':');
      if(p.length < 2) return;
      const k = String(p[0]||'').trim().toLowerCase();
      let v = String(p.slice(1).join(':')||'').trim();
      if(!allow.has(k) || !v) return;
      if(/url\s*\(/i.test(v)) return; // block url(...)
      if(k === 'font-size'){
        // only px sizes 8..48
        const m = v.match(/(\d{1,3})\s*px/i);
        if(!m) return;
        let n = Math.max(8, Math.min(48, parseInt(m[1],10)));
        v = n + 'px';
      }
      out.push(k + ':' + v);
    });
    return out.join(';');
  }

  function sanitizeRichHtml(html){
    html = String(html||'');
    if(!html.trim()) return '';
    let doc;
    try{
      doc = new DOMParser().parseFromString('<div id="__wrap">' + html + '</div>', 'text/html');
    }catch(_e){
      return '';
    }
    const wrap = doc.getElementById('__wrap');
    if(!wrap) return '';

    const walk = (node) => {
      if(!node) return;
      const kids = Array.from(node.childNodes || []);
      for(const child of kids){
        if(child.nodeType === 1){
          const tag = child.tagName;
          if(!RICH_ALLOWED_TAGS.has(tag)){
            // unwrap: keep text/children
            const frag = doc.createDocumentFragment();
            while(child.firstChild) frag.appendChild(child.firstChild);
            child.replaceWith(frag);
            continue;
          }

          // strip attrs
          const allowA = RICH_ALLOWED_ATTRS[tag] || new Set();
          Array.from(child.attributes || []).forEach(a => {
            const name = String(a.name||'').toLowerCase();
            if(name.startsWith('on')){ child.removeAttribute(a.name); return; }
            if(!allowA.has(a.name)){
              if(a.name !== 'style') child.removeAttribute(a.name);
            }
          });

          if(tag === 'A'){
            const href = safeUrl(child.getAttribute('href'));
            if(!href){
              // unwrap link if unsafe
              const frag2 = doc.createDocumentFragment();
              while(child.firstChild) frag2.appendChild(child.firstChild);
              child.replaceWith(frag2);
              continue;
            }
            child.setAttribute('href', href);
            child.setAttribute('target', '_blank');
            child.setAttribute('rel', 'noopener noreferrer');
          }
          if(tag === 'IMG'){
            const src = safeUrl(child.getAttribute('src'));
            if(!src){ child.remove(); continue; }
            child.setAttribute('src', src);
            child.setAttribute('loading', 'lazy');
            child.removeAttribute('srcset');
          }
          if(tag === 'IFRAME'){
            const src = safeUrl(child.getAttribute('src'));
            if(!src){ child.remove(); continue; }
            child.setAttribute('src', src);
            child.setAttribute('loading', 'lazy');
            child.removeAttribute('srcdoc');
          }

          if(child.hasAttribute('style')){
            const s = sanitizeStyle(child.getAttribute('style'));
            if(s) child.setAttribute('style', s);
            else child.removeAttribute('style');
          }

          walk(child);
        }else if(child.nodeType === 8){
          // comment
          child.remove();
        }else{
          // text ok
        }
      }
    };

    walk(wrap);
    return wrap.innerHTML;
  }


  // ===== Auto media embeds (frontend only) =====
  // Converts plain URLs / <a href> inside rendered post/comment bodies into embeds.
  // Supports:
  // - YouTube video
  // - YouTube playlist (videoseries)
  // - iq.com (tries iframe; if blocked, shows "Open video" button)
  function _slbTryUrl_(u){
    try{ return new URL(String(u||"").trim()); }catch(_e){ return null; }
  }

  function _slbMediaClassify_(url){
    const U = _slbTryUrl_(url);
    if(!U) return null;
    const host = String(U.hostname||"").replace(/^www\./i,"").toLowerCase();

    const isYT = (host === "youtube.com" || host.endsWith(".youtube.com") || host === "youtu.be");
    if(isYT){
      const listId = U.searchParams.get("list");
      // video id
      let vid = U.searchParams.get("v");
      if(!vid && host === "youtu.be"){
        const p = String(U.pathname||"").replace(/^\/+/,"").split(/[/?#]/)[0];
        vid = p || null;
      }
      if(!vid){
        const m = String(U.pathname||"").match(/\/(embed|shorts)\/([A-Za-z0-9_-]{6,})/i);
        if(m) vid = m[2];
      }

      if(listId){
        // Prefer playlist embed if a list is provided
        return { type:"yt_playlist", listId: String(listId) };
      }
      if(vid){
        return { type:"yt_video", videoId: String(vid) };
      }
      return null;
    }

    if(host === "iq.com" || host.endsWith(".iq.com")){
      return { type:"iq", url: U.toString() };
    }

    return null;
  }

  function _slbMediaEmbedHtml_(info){
    if(!info) return "";
    if(info.type === "yt_playlist"){
      const src = safeUrl("https://www.youtube.com/embed/videoseries?list=" + encodeURIComponent(info.listId||""));
      if(!src) return "";
      return '<div class="slbYtEmbed slbMediaEmbed" contenteditable="false"><iframe src="' + src + '" title="YouTube playlist" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>';
    }
    if(info.type === "yt_video"){
      const src = safeUrl("https://www.youtube.com/embed/" + encodeURIComponent(info.videoId||"") + "?rel=0");
      if(!src) return "";
      return '<div class="slbYtEmbed slbMediaEmbed" contenteditable="false"><iframe src="' + src + '" title="YouTube video" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>';
    }
    if(info.type === "iq"){
      const src = safeUrl(info.url||"");
      if(!src) return "";
      // Note: iq.com may block iframe embeds via CSP/X-Frame-Options.
      // We still try, but always provide a fallback open button.
      return (
        '<div class="slbYtEmbed slbMediaEmbed slbIqEmbed" contenteditable="false">' +
          '<iframe src="' + src + '" title="Video" frameborder="0" loading="lazy" allow="autoplay; encrypted-media; fullscreen" allowfullscreen></iframe>' +
        '</div>' +
        '<div class="slbMediaFallback" contenteditable="false">' +
          '<a class="slbMediaOpen" href="' + src + '" target="_blank" rel="noopener noreferrer">Open video</a>' +
        '</div>'
      );
    }
    return "";
  }

  function _slbLinkify_(root){
    if(!root) return;
    const urlRe = /\bhttps?:\/\/[^\s<]+/gi;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    const nodes = [];
    while(walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(tn => {
      const text = tn.nodeValue || "";
      if(!text || !urlRe.test(text)) return;

      const frag = document.createDocumentFragment();
      let last = 0;
      text.replace(urlRe, (m, idx) => {
        if(idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
        const a = document.createElement("a");
        a.href = m;
        a.textContent = m;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        frag.appendChild(a);
        last = idx + m.length;
        return m;
      });
      if(last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));

      try{ tn.parentNode && tn.parentNode.replaceChild(frag, tn); }catch(_e){}
    });
  }

  function _slbAutoEmbed_(container){
    if(!container) return;
    if(container.__slbAutoEmbedDone) return;
    container.__slbAutoEmbedDone = true;

    // Turn plain URLs into anchors first
    try{ _slbLinkify_(container); }catch(_e){}

    const anchors = Array.from(container.querySelectorAll('a[href]'));
    anchors.forEach(a => {
      if(!a || !a.getAttribute) return;
      if(a.closest('.slbYtEmbed, .slbMediaEmbed')) return;

      const href = String(a.getAttribute('href')||'').trim();
      if(!/^https?:\/\//i.test(href)) return;

      const info = _slbMediaClassify_(href);
      if(!info) return;

      const html = _slbMediaEmbedHtml_(info);
      if(!html) return;

      // Replace a "standalone" link block for cleaner layout
      const block = a.closest('p, div, li, blockquote') || a;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const frag = document.createDocumentFragment();
      Array.from(tmp.childNodes).forEach(n => frag.appendChild(n));
      try{ block.parentNode && block.parentNode.replaceChild(frag, block); }catch(_e){}
    });
  }

  function htmlToText(html){
    try{
      const d = document.createElement('div');
      d.innerHTML = String(html||'');
      return String(d.textContent||'').replace(/\s+$/,'');
    }catch(_e){
      return String(html||'');
    }
  }

  function richEl(){ return $("#slbLibBodyRich"); }
  function setRichEditorHtml(html){
    const el = richEl();
    if(!el) return;
    el.innerHTML = sanitizeRichHtml(html);
  }
  function clearRichEditor(){
    const el = richEl();
    if(!el) return;
    el.innerHTML = '';
  }
  function getRichEditorHtml(){
    const el = richEl();
    if(!el) return '';
    return sanitizeRichHtml(el.innerHTML || '');
  }

  function fmtTime(t){
    const s = String(t||"");
    if(!s) return "";
    // Keep as-is; just shorten if ISO
    return s.replace("T"," ").slice(0,19);
  }

  // Compute last activity for list display.
  // Backend bumps post.updatedAt on comment add (often within the same second), so we
  // prefer the latest comment author when its timestamp is close to updatedAt.
  function computeLastActivityForList_(p){
    p = p || {};
    const baseBy = String(p.author||"").trim();
    const baseAt = String(p.updatedAt||p.createdAt||"").trim();

    const hit = getDetailCache(String(p.postId||""));
    const d = hit && hit.data ? hit.data : null;
    const comments = (d && d.comments) ? d.comments : null;

    // default
    let outBy = baseBy;
    let outAt = baseAt;

    if(comments && comments.length){
      // latest comment
      let bestC = null;
      let bestT = -1;
      for(let i=0;i<comments.length;i++){
        const c = comments[i] || {};
        const dt = parseAnyDate_(c.createdAt);
        const t = dt ? dt.getTime() : -1;
        if(t >= bestT){ bestT = t; bestC = c; }
      }
      if(bestC && bestT >= 0){
        const baseD = parseAnyDate_(baseAt);
        const baseT = baseD ? baseD.getTime() : -1;
        // If updatedAt is within 2 seconds after the comment (common bump behavior), show commenter.
        if(baseT >= 0 && baseT >= bestT && (baseT - bestT) <= 2000){
          outBy = String(bestC.author||baseBy||"").trim();
          outAt = baseAt || String(bestC.createdAt||"").trim();
        }else if(baseT < 0 || bestT > baseT){
          outBy = String(bestC.author||baseBy||"").trim();
          outAt = String(bestC.createdAt||baseAt||"").trim();
        }
      }
    }

    return {
      by: outBy || baseBy || "",
      at: outAt || baseAt || ""
    };
  }

  function _libUpdateListMetaForPost_(postId){
    try{
      const pid = String(postId||"");
      if(!pid) return;
      const list = $("#slbLibList");
      if(!list) return;
      const card = list.querySelector('[data-post-id="' + CSS_ESCAPE(pid) + '"]');
      if(!card) return;
      const metaEl = card.querySelector('.slbLibColUpdated');
      if(!metaEl) return;
      const p = (S.posts||[]).find(x => String(x && x.postId || "") === pid) || { postId: pid };
      const act = computeLastActivityForList_(p);
      const who = String(act.by||"").trim();
      const when = fmtLocalStamp(act.at);
      const meta = (who + ' • ' + when).trim();
      metaEl.textContent = meta;
    }catch(_e){}
  }

  function parseAnyDate_(t){
    const s = String(t||"").trim();
    if(!s) return null;

    // unix seconds / milliseconds
    if(/^\d{10,13}$/.test(s)){
      const n = Number(s);
      const ms = (n < 1e12) ? (n * 1000) : n;
      const d = new Date(ms);
      return isNaN(d.getTime()) ? null : d;
    }

    // ISO / browser-parseable
    let d = new Date(s);
    if(!isNaN(d.getTime())) return d;

    // "YYYY-MM-DD HH:mm:ss" (treat as UTC to avoid browser locale quirks)
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/);
    if(m){
      const iso = m[1] + "-" + m[2] + "-" + m[3] + "T" + m[4] + ":" + m[5] + ":" + (m[6]||"00") + "Z";
      d = new Date(iso);
      if(!isNaN(d.getTime())) return d;
    }
    return null;
  }

  function fmtLocalStamp(t){
    const d = parseAnyDate_(t);
    if(!d) return fmtTime(t);
    const mons = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mon = mons[d.getMonth()] || "";
    const day = d.getDate();
    const yr = d.getFullYear();
    const hh = String(d.getHours()).padStart(2,"0");
    const mm = String(d.getMinutes()).padStart(2,"0");
    return mon + ", " + day + ", " + yr + " @ " + hh + ":" + mm;
  }

  function fmtLocalDateShort(t){
    const d = parseAnyDate_(t);
    if(!d) return fmtTime(t);
    return d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate();
  }


  function nowIso(){ return new Date().toISOString(); }

  function makeTmpId(prefix){
    return (prefix||"tmp") + "_" + Date.now().toString(36) + "_" + Math.random().toString(36).slice(2,8);
  }

  function listCacheKey(catId, q){
    return String(catId||"") + "||" + String(q||"");
  }

  function getListCache(catId, q){
    const key = listCacheKey(catId, q);
    const hit = S.cache.lists[key];
    if(!hit) return null;
    hit.stale = (Date.now() - hit.ts > 60000);
    return hit;
  }

  function setListCache(catId, q, posts, cats){
    const key = listCacheKey(catId, q);
    S.cache.lists[key] = { ts: Date.now(), posts: posts || [], cats: cats || null };
  }

  // Persisted list cache (survives page reload, improves the "first click" speed)
  const PERSIST_LIST_TTL_MS = 5*60*1000; // 5 min
  const PERSIST_BOOT_TTL_MS = 24*60*60*1000; // 1 day
  function getCacheNs(){
    try{
      const app = getApp();
      const st = app && app.getState ? app.getState() : null;
      const cs = (st && st.callsign) ? String(st.callsign) : String(sessionStorage.getItem("tyw_callsign")||"");
      return (cs||"anon").toUpperCase();
    }catch(_e){ return "ANON"; }
  }
  function persistKey(){ return "slb_lib_cache_v1_" + getCacheNs(); }
  function loadPersist(){
    try{ return JSON.parse(localStorage.getItem(persistKey()) || "null") || {}; }catch(_e){ return {}; }
  }
  function savePersist(o){
    try{ localStorage.setItem(persistKey(), JSON.stringify(o || {})); }catch(_e){}
  }
  function getPersistList(catId, q){
    q = String(q||"").trim();
    if(q) return null; // keep it small: persist only the no-search list
    const c = loadPersist();
    const node = c && c.lists ? c.lists[String(catId||"")] : null;
    if(!node || !node.ts) return null;
    node.stale = (Date.now() - Number(node.ts||0) > PERSIST_LIST_TTL_MS);
    return node;
  }
  function setPersistList(catId, q, posts, cats){
    q = String(q||"").trim();
    if(q) return; // keep it small
    const c = loadPersist();
    if(!c.lists) c.lists = {};
    // cap to avoid huge localStorage
    const safePosts = (posts || []).slice(0, 250);
    c.lists[String(catId||"")] = { ts: Date.now(), posts: safePosts, cats: cats || null };
    savePersist(c);
  }
  function getPersistBootstrap(){
    const c = loadPersist();
    const b = c && c.bootstrap ? c.bootstrap : null;
    if(!b || !b.ts) return null;
    b.stale = (Date.now() - Number(b.ts||0) > PERSIST_BOOT_TTL_MS);
    return b;
  }
  function setPersistBootstrap(data){
    const c = loadPersist();
    c.bootstrap = { ts: Date.now(), data: data || null };
    savePersist(c);
  }

  // Offline read-cache (from slb.offline.js) — used to avoid "Loading..." flicker when switching tabs.
  function peekOfflineMeta(action, args){
    try{
      if(window.SLB_OFFLINE && typeof window.SLB_OFFLINE.peekReadMeta === "function"){
        return window.SLB_OFFLINE.peekReadMeta(action, args);
      }
    }catch(_e){}
    return null;
  }

  
  function getOfflineDetailIfAny(postId){
    try{
      const pid = String(postId||"");
      if(!pid) return null;
      if(window.SLB_OFFLINE && typeof window.SLB_OFFLINE.getReadCached === "function"){
        return window.SLB_OFFLINE.getReadCached("libraryGet", { postId: pid }) ||
               window.SLB_OFFLINE.getReadCached("libGet", { postId: pid }) ||
               null;
      }
    }catch(_e){}
    return null;
  }

function applyOfflineListIfAny(catId, q){
    try{
      const meta = peekOfflineMeta("libraryList", { catId: catId || "", q: q || "" });
      if(meta && meta.data && (meta.data.posts || meta.data.cats)){
        const d = meta.data;
        // seed local caches so the UI can render instantly
        setListCache(catId, q, d.posts || [], d.cats || null);
        if(!q) { try{ setPersistList(catId, q, d.posts || [], d.cats || null); }catch(_e2){} }
        if(d.cats) S.cats = d.cats;
        S.posts = d.posts || [];
        renderCats();
        renderList();
        return true;
      }
    }catch(_e){}
    return false;
  }

function getDetailCache(postId){
    const hit = S.cache.details[String(postId||"")];
    if(!hit) return null;
    hit.stale = (Date.now() - hit.ts > 60000);
    return hit;
  }

  function setDetailCache(postId, data){
    S.cache.details[String(postId||"")] = { ts: Date.now(), data };
  }

  
  function _libWarmOneDetail(postId){
    const pid = String(postId||"");
    if(!pid) return;
    // memory cache hit
    const hit = getDetailCache(pid);
    if(hit) return;

    // offline read-cache hit
    const off = getOfflineDetailIfAny(pid);
    if(off){
      try{ setDetailCache(pid, off); }catch(_e){}
      try{ _libUpdateListMetaForPost_(pid); }catch(_e2){}
      return;
    }

    // de-dupe in-flight requests
    try{
      if(!S._warmDetailInFlight) S._warmDetailInFlight = Object.create(null);
      if(S._warmDetailInFlight[pid]) return;
      S._warmDetailInFlight[pid] = 1;
    }catch(_e){}

    // background fetch (quiet)
    rpcAny("LIB_GET", ["libraryGet","libGet"], { postId: pid })
      .then(data => { 
        try{ setDetailCache(pid, data); }catch(_e){}
        try{ _libUpdateListMetaForPost_(pid); }catch(_e2){}
      })
      .catch(() => {})
      .finally(() => { try{ delete S._warmDetailInFlight[pid]; }catch(_e){} });
  }

  function _libWarmListTopDetails(){
    try{
      const token = (S._warmListToken = (Number(S._warmListToken||0) + 1));
      const posts = (S.posts || []).slice(0, 30);
      for(let i=0;i<posts.length;i++){
        const p = posts[i];
        const pid = p && p.postId;
        setTimeout(() => {
          try{
            if(Number(S._warmListToken||0) !== token) return;
            _libWarmOneDetail(pid);
          }catch(_e){}
        }, 60 * i);
      }
    }catch(_e){}
  }

function upsertPostInArray(arr, post, tempId){
    arr = arr || [];
    const pid = String(post && post.postId || "");
    const tid = String(tempId||"");
    let idx = -1;
    if(tid){
      idx = arr.findIndex(x => String(x.postId||"") === tid);
    }
    if(idx < 0 && pid){
      idx = arr.findIndex(x => String(x.postId||"") === pid);
    }
    if(idx >= 0){
      arr[idx] = post;
      return arr;
    }
    // default: prepend
    return [post, ...arr];
  }

  function removePostFromArray(arr, postId){
    const pid = String(postId||"");
    return (arr||[]).filter(x => String(x.postId||"") !== pid);
  }


  function getApp(){
    return window.SLB_APP || null;
  }

  async function rpc(action, args, opts){
  const app = getApp();
  if(!app || !app.rpc) throw new Error("App not ready");
  opts = opts || {};
  // Chunk progress toasts: label write actions so the % toast is meaningful
  if(!opts.progressLabel){
    const a = String(action||"");
    if(a==="libraryPostUpsert" || a==="libraryCommentAdd" || a==="adminLibraryCatsUpsert" || a==="adminLibraryGroupsUpsert"){
      opts.progressLabel = "Saving";
    }else if(a==="libraryPostDelete" || a==="libraryCommentDelete" || a==="adminLibraryCatsDelete" || a==="adminLibraryGroupsDelete"){
      opts.progressLabel = "Deleting";
    }
  }
  return await app.rpc(action, args || {}, opts);
}

async function rpcAny(cacheKey, candidates, args, opts){
  try{
    const a = getApp();
    if(a && typeof a.rpcTryCached === 'function' && Array.isArray(candidates) && candidates.length){
      return await a.rpcTryCached(String(cacheKey||''), candidates, args || {}, opts || {});
    }
  }catch(_e){}
  const first = (Array.isArray(candidates) && candidates[0]) ? candidates[0] : String(cacheKey||'');
  return await rpc(first, args || {}, opts || {});
}

  

function libEnsureGlobalMsgBox(){
  try{
    const p = panel();
    if(!p) return null;
    let box = document.getElementById('slbLibGlobalMsg');
    if(box) return box;
    box = document.createElement('div');
    box.id = 'slbLibGlobalMsg';
    box.className = 'err';
    box.style.margin = '10px 0';
    box.style.padding = '10px 12px';
    box.style.borderRadius = '12px';
    box.style.fontWeight = '800';
    box.style.display = 'none';
    // Insert right under the intro note
    const firstNote = p.querySelector('.note');
    if(firstNote && firstNote.parentNode === p){
      firstNote.insertAdjacentElement('afterend', box);
    }else{
      p.insertAdjacentElement('afterbegin', box);
    }
    return box;
  }catch(_e){ return null; }
}

function libShowGlobalMsg(kind, text){
  try{
    const box = libEnsureGlobalMsgBox();
    if(!box) return;
    box.classList.remove('ok','err','hidden');
    box.classList.add(kind === 'ok' ? 'ok' : 'err');
    box.textContent = String(text == null ? '' : text);
    box.style.display = box.textContent ? 'block' : 'none';
  }catch(_e){}
}

function libToast(kind, text){
  try{
    const a = getApp();
    if(a && typeof a.toast === 'function') a.toast(kind === 'ok' ? 'ok' : 'err', String(text||''));
  }catch(_e){}
}

function libErr(text){
  const t = String(text||'');
  libToast('err', t);
  libShowGlobalMsg('err', t);
}

function libOk(text){
  const t = String(text||'');
  libToast('ok', t);
  libShowGlobalMsg('ok', t);
}

// ===== Library "Send To" (targeted email) modal =====
let _libSendToModal = null;

function _libRoot_(){
  return (document.getElementById("SaamLawBank") || document.getElementById("tyWealthCourtyard") || document.body);
}

function libSendToEnsureModal_(){
  if(_libSendToModal && _libSendToModal.mask && _libSendToModal.modal) return _libSendToModal;

  const mask = document.createElement("div");
  mask.id = "slbLibSendToMask";
  mask.className = "slbModalMask";

  const modal = document.createElement("div");
  modal.id = "slbLibSendToModal";
  modal.className = "slbModal";
  // Ensure modal text inherits the SLB theme text color (dark mode safe)
  modal.style.color = "var(--slb-text,#0f1517)";
  modal.innerHTML = `
    <h4>Send Library Link</h4>
    <div class="note">Choose one or more people from the notification list. They will receive an email with the link to this Library post.</div>

    <div class="row" style="gap:8px;align-items:center;flex-wrap:wrap;">
      <input class="inp" id="slbLibSendToSearch" placeholder="Search callsign..." style="flex:1;min-width:200px;" />
      <button class="btn soft" id="slbLibSendToAll" type="button">All</button>
      <button class="btn soft" id="slbLibSendToNone" type="button">None</button>
    </div>

    <div class="row" id="slbLibSendToList" style="max-height:320px;overflow:auto;border:1px solid var(--slb-border,#e2e6ea);border-radius:12px;padding:8px;color:var(--slb-text,#0f1517);"></div>

    <div class="note" id="slbLibSendToMsg" style="display:none;"></div>

    <div class="actions">
      <button class="btn orange" id="slbLibSendToSend" type="button">Send</button>
      <button class="btn soft" id="slbLibSendToCancel" type="button">Cancel</button>
    </div>
  `;

  _libRoot_().appendChild(mask);
  _libRoot_().appendChild(modal);

  const close = ()=>{
    mask.classList.remove("show");
    modal.classList.remove("show");
    try{ const msg = modal.querySelector("#slbLibSendToMsg"); if(msg){ msg.style.display="none"; msg.textContent=""; } }catch(_e){}
  };
  mask.addEventListener("click", close);
  const cancel = modal.querySelector("#slbLibSendToCancel");
  if(cancel) cancel.addEventListener("click", close);

  _libSendToModal = { mask, modal, close };
  return _libSendToModal;
}

function _libSendToRenderList_(recips, filter){
  const W = libSendToEnsureModal_();
  const list = W.modal.querySelector("#slbLibSendToList");
  if(!list) return;
  const q = String(filter||"").trim().toUpperCase();
  const arr = (recips||[]).slice().sort((a,b)=>String(a.callsign||"").localeCompare(String(b.callsign||"")));
  const showArr = q ? arr.filter(r=>String(r.callsign||"").toUpperCase().includes(q)) : arr;

  if(!showArr.length){
    list.innerHTML = `<div class="note">No matches.</div>`;
    return;
  }

  list.innerHTML = showArr.map(r=>{
    const cs = esc(String(r.callsign||""));
    const em = esc(String(r.email||""));
    return `
      <label style="display:flex;align-items:center;gap:8px;padding:6px 4px;border-radius:10px;cursor:pointer;color:var(--slb-text,#0f1517);">
        <input type="checkbox" class="slbLibSendToChk" data-email="${em}" />
        <span style="font-weight:800;min-width:90px;">${cs}</span>
        <span style="color:var(--slb-muted,#6b7680);font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">${em}</span>
      </label>
    `;
  }).join("");
}

async function libSendToOpen_(post){
  if(!(S.canAdmin || S.canMod)) return;

  const W = libSendToEnsureModal_();
  W.mask.classList.add("show");
  W.modal.classList.add("show");

  // Load recipients (cached)
  if(!S.__libNotifyRecips){
    try{
      const out = await rpc("libraryNotifyRecipients", {});
      S.__libNotifyRecips = (out && out.recipients) ? out.recipients : [];
    }catch(e){
      S.__libNotifyRecips = [];
      const msg = W.modal.querySelector("#slbLibSendToMsg");
      if(msg){
        msg.textContent = "Failed to load list: " + String(e && (e.message||e) || "Error");
        msg.style.display = "block";
      }
    }
  }

  _libSendToRenderList_(S.__libNotifyRecips, "");

  const search = W.modal.querySelector("#slbLibSendToSearch");
  if(search && !search.__slbBound){
    search.__slbBound = true;
    search.addEventListener("input", ()=>{ _libSendToRenderList_(S.__libNotifyRecips, search.value); });
  }else{
    try{ if(search) search.value = ""; }catch(_e){}
  }

  const btnAll = W.modal.querySelector("#slbLibSendToAll");
  if(btnAll && !btnAll.__slbBound){
    btnAll.__slbBound = true;
    btnAll.addEventListener("click", ()=>{
      W.modal.querySelectorAll(".slbLibSendToChk").forEach(x=>{ try{x.checked=true;}catch(_e){} });
    });
  }
  const btnNone = W.modal.querySelector("#slbLibSendToNone");
  if(btnNone && !btnNone.__slbBound){
    btnNone.__slbBound = true;
    btnNone.addEventListener("click", ()=>{
      W.modal.querySelectorAll(".slbLibSendToChk").forEach(x=>{ try{x.checked=false;}catch(_e){} });
    });
  }

  const sendBtn = W.modal.querySelector("#slbLibSendToSend");
  if(sendBtn && !sendBtn.__slbBound){
    sendBtn.__slbBound = true;
    sendBtn.addEventListener("click", async ()=>{
      const msg = W.modal.querySelector("#slbLibSendToMsg");
      const checks = Array.from(W.modal.querySelectorAll(".slbLibSendToChk") || []);
      const emails = checks.filter(x=>x && x.checked).map(x=>String(x.getAttribute("data-email")||"").trim()).filter(Boolean);

      if(!emails.length){
        if(msg){ msg.textContent = "Please choose at least one person."; msg.style.display="block"; }
        return;
      }

      if(sendBtn) sendBtn.disabled = true;
      try{
        const baseUrl = (location && location.origin ? (location.origin + location.pathname) : "");
        const P = (W.modal.__slbPost || null);
        const out = await rpc("libraryNotifySendTo", {
          postId: P && P.postId,
          title: P && P.title,
          baseUrl: baseUrl,
          to: emails
        });
        if(msg){
          msg.textContent = "Sent: " + String((out && out.sent) || 0) + " (requested " + String((out && out.requested) || emails.length) + ")";
          msg.style.display="block";
        }
      }catch(e){
        if(msg){
          msg.textContent = "Send failed: " + String(e && (e.message||e) || "Error");
          msg.style.display="block";
        }
      }finally{
        if(sendBtn) sendBtn.disabled = false;
      }
    });
  }

  // Store post context (so sendBtn handler knows which post)
  W.modal.__slbPost = post || null;
  // Patch send handler to always use latest post (safe)
  try{
    const sendBtn2 = W.modal.querySelector("#slbLibSendToSend");
    if(sendBtn2) sendBtn2.__slbGetPost = ()=>W.modal.__slbPost;
  }catch(_e){}
}

const S = {
    booted:false,
    adminMode:false,
    threadMode:false,
    cats:[],
    myGroups:[],
    canAdmin:false,
    canMod:false,
    activeCat:"",
    posts:[],
    selectedPostId:"",
    // Detail view: comment paging (UI only)
    commentPage:Object.create(null),
    commentPageSize:10,
    bootstrapLoaded:false,

    page: 1,
    pageSize: 15,

    // lightweight client cache for snappier UI
    cache:{
      bootstrap:null,      // {ts,data}
      lists:Object.create(null), // key -> {ts, posts, cats}
      details:Object.create(null), // postId -> {ts, data}
    },

    // request sequencing (avoid out-of-order UI updates)
    req: { listSeq: 0, detailSeq: 0, lastErrToast: 0 },
  };

  function panel(){
    return $("#slbLibraryPanel");
  }

  function show(el){ if(el) el.classList.remove("hidden"); }
  function hide(el){ if(el) el.classList.add("hidden"); }

  // ===== Deep links (Library posts) =====
  // Canonical format: #tab=myCabin&cabin=library&postId=LIB_xxx. Old #library links are still accepted.
  function _libReadHash_(){
    const raw = String(location.hash||"");
    if(!raw) return { tab:"", sp:null };
    let h = raw.replace(/^#/, "");
    if(h.startsWith("?")) h = h.slice(1);
    // query-only hash: tab=library&postId=...
    if(h.startsWith("tab=")){
      try{
        h = String(h||"").replace(/&amp;/g,"&");
        const sp = new URLSearchParams(String(h||"").replace(/&amp;/g, "&"));
        let tab = String(sp.get("tab")||"");
        if(tab === "myCabin" && String(sp.get("cabin")||"") === "library") tab = "library";
        return { tab, sp };
      }catch(_e){
        return { tab:"", sp:null };
      }
    }
    const parts = h.split("?");
    const tab = String(parts[0]||"");
    const qs  = String(parts[1]||"");
    let sp = null;
    try{ sp = new URLSearchParams(qs); }catch(_e){}
    return { tab, sp };
  }

  function _libHashPostId_(){
    const h = _libReadHash_();
    if(String(h.tab||"").toLowerCase() !== "library") return "";
    try{ return String((h.sp && (h.sp.get("postId") || h.sp.get("amp;postId") || h.sp.get("pid") || h.sp.get("amp;pid") || h.sp.get("id") || h.sp.get("amp;id"))) || ""); }catch(_e){ return ""; }
  }

  function _libSetDeepLink_(postId){
    try{
      const pid = String(postId||"").trim();
      const hash = pid ? ("#tab=myCabin&cabin=library&postId=" + encodeURIComponent(pid)) : "#tab=myCabin&cabin=library";
      if(history && history.replaceState){
        history.replaceState(null, "", hash);
      }else{
        location.hash = hash;
      }
    }catch(_e){}
  }

  function _libMaybeOpenFromHash_(){
    try{
      const pid = _libHashPostId_();
      if(!pid) return;

      const same = (String(S.selectedPostId||"") === String(pid));
      // If we're already in thread view for the same post, do nothing.
      if(same && S.threadMode) return;

      // IMPORTANT: reload() forces list view first; if we skip opening when the id is the same,
      // a second reload will leave the detail panel blank. Always re-open on deep links.
      if(!same) S.selectedPostId = pid;

      setTimeout(()=>{ try{ openPost(pid).catch(()=>{}); }catch(_e){} }, 0);
    }catch(_e){}
  }

  function setView(mode){
    const top = $("#slbLibSearchWrap") || $("#slbLibTopBar");
    const cats = $("#slbLibCats");
    const composer = $("#slbLibComposer");
    const divider = $("#slbLibDivider");
    const header = $("#slbLibListHeader");
    const list = $("#slbLibList");
    const pager = $("#slbLibPager");
    const detail = $("#slbLibDetail");
    const admin = $("#slbLibAdminBox");

    if(mode === "thread"){
      S.threadMode = true;
      S.adminMode = false;
      hide(top); hide(cats); hide(composer); hide(divider); hide(header); hide(list); hide(pager); hide(admin);
      show(detail);
      return;
    }

    if(mode === "admin"){
      S.adminMode = true;
      S.threadMode = false;
      hide(top); hide(cats); hide(composer); hide(divider); hide(header); hide(list); hide(pager); hide(detail);
      show(admin);
      return;
    }

    // list mode
    S.adminMode = false;
    S.threadMode = false;
    show(cats);
    if(S.activeCat){ show(top); show(divider); show(header); show(list); show(pager); } else { hide(top); hide(divider); hide(header); hide(list); hide(pager); }
    hide(detail); hide(admin);
    // composer stays as-is (New/Edit can show it)
  }

  function enterAdminMode(){
    if(!(S.canAdmin || S.canMod)) return;
    setView("admin");
    showAdminTools(S._bootstrapAllGroups || null);
    const msg = $("#slbLibAdminMsg"); if(msg) msg.textContent = "";
  }

  function exitAdminMode(){
    setView("list");
    const msg = $("#slbLibAdminMsg"); if(msg) msg.textContent = "";
  }

  function currentCallsign(){
    const app = getApp();
    return (app && app.S && app.S.callsign) ? String(app.S.callsign).toUpperCase() : "";
  }

  function catNameById(id){
    id = String(id||"");
    const c = S.cats.find(x => String(x.catId||"") === id);
    return c ? c.name : id;
  }

  function pickDefaultCatId_(){
    const cats = S.cats || [];
    if(!cats.length) return "";
    const hitByName = cats.find(c => String(c && c.name || "").toLowerCase().includes("announce"));
    if(hitByName && hitByName.catId) return String(hitByName.catId);
    const hitById = cats.find(c => String(c && c.catId || "").toLowerCase().includes("announce"));
    if(hitById && hitById.catId) return String(hitById.catId);
    return String((cats[0] && cats[0].catId) || "");
  }

  function renderCats(){
    const wrap = $("#slbLibCats");
    if(!wrap) return;
    const mkChip = (id, label) => {
      const btn = document.createElement("button");
      btn.type="button";
      btn.className = "chip" + (String(S.activeCat||"")===String(id||"") ? " on" : "");
      btn.dataset.catId = id || "";
      btn.textContent = label;
      return btn;
    };
    wrap.innerHTML = "";
    (S.cats||[]).forEach(c => {
      if(c && c.catId){
        wrap.appendChild(mkChip(c.catId, c.name || c.catId));
      }
    });

    // composer select
    const sel = $("#slbLibCat");
    if(sel){
      // Preserve the user's current selection across re-renders (bg sync / bootstrap refresh),
      // otherwise it can jump back to the first option (often "Announcement").
      const prev = String(sel.value||"");
      sel.innerHTML = "";
      (S.cats||[]).forEach(c => {
        const opt = document.createElement("option");
        opt.value = c.catId;
        opt.textContent = c.name || c.catId;
        sel.appendChild(opt);
      });
      if(prev && (S.cats||[]).some(c => String(c && c.catId || "") === prev)){
        sel.value = prev;
      }else if(!sel.value && S.cats[0]){
        sel.value = S.cats[0].catId;
      }
    }
  }


  // ===== Sorting (Library list) =====
  function _libGetSortMode_(){
    let m = "";
    try{ m = String(S.sortMode||""); }catch(_e){}
    if(!m){
      try{ m = String(localStorage.getItem("slb_lib_sort")||""); }catch(_e2){}
    }
    m = String(m||"").trim() || "updated_desc";
    return m;
  }

  function _libSetSortMode_(m){
    m = String(m||"").trim() || "updated_desc";
    try{ S.sortMode = m; }catch(_e){}
    try{ localStorage.setItem("slb_lib_sort", m); }catch(_e2){}
  }

  function _libSortTs_(p){
    try{
      const act = computeLastActivityForList_(p||{});
      const d = parseAnyDate_(act && act.at);
      const t = d ? d.getTime() : -1;
      if(t >= 0) return t;
    }catch(_e){}
    try{
      const d2 = parseAnyDate_((p && (p.updatedAt||p.createdAt)) || "");
      return d2 ? d2.getTime() : -1;
    }catch(_e2){}
    return -1;
  }

  function _libSortPosts_(arr){
    arr = arr || [];
    const mode = _libGetSortMode_();
    const cmpTitle = (a,b) => {
      const ta = String(a && a.title || "").toLowerCase();
      const tb = String(b && b.title || "").toLowerCase();
      if(ta < tb) return -1;
      if(ta > tb) return 1;
      return 0;
    };
    arr.sort((a,b) => {
      const ap = !!(a && a.isPinned);
      const bp = !!(b && b.isPinned);
      if(ap !== bp) return ap ? -1 : 1; // pinned always first

      if(mode === "title_asc"){
        const c = cmpTitle(a,b);
        if(c) return c;
        return _libSortTs_(b) - _libSortTs_(a);
      }
      if(mode === "title_desc"){
        const c = cmpTitle(a,b);
        if(c) return -c;
        return _libSortTs_(b) - _libSortTs_(a);
      }
      if(mode === "created_desc"){
        const da = parseAnyDate_((a && a.createdAt) || "");
        const db = parseAnyDate_((b && b.createdAt) || "");
        const ta = da ? da.getTime() : -1;
        const tb = db ? db.getTime() : -1;
        if(tb !== ta) return tb - ta;
        return _libSortTs_(b) - _libSortTs_(a);
      }

      // default: updated_desc
      const ua = _libSortTs_(a);
      const ub = _libSortTs_(b);
      if(ub !== ua) return ub - ua;
      return cmpTitle(a,b);
    });
    return arr;
  }

  function renderList(){
    const list = $("#slbLibList");
    const header = $("#slbLibListHeader");
    const pager = $("#slbLibPager");
    if(!list) return;

    // Ensure header/pager visibility is in sync
    try{ if(header) header.classList.toggle('hidden', !(S.posts||[]).length); }catch(_e){}
    try{ if(pager) pager.classList.toggle('hidden', !(S.posts||[]).length); }catch(_e){}

    // Preserve scroll anchor so list updates don't make the page jump.
    let anchorId = "";
    let anchorTop = 0;
    let pinScroll = true;
    try{
      const cards = $$(".slbLibPostCard", list);
      for(let i=0;i<cards.length;i++){
        const c = cards[i];
        const r = c.getBoundingClientRect();
        if(r.bottom > 0 && r.top < window.innerHeight){
          anchorId = String(c.dataset.postId||"");
          anchorTop = r.top;
          if(i === 0 && r.top < 160){ pinScroll = false; }
          break;
        }
      }
    }catch(_e){}

    list.innerHTML = "";
    const all = _libSortPosts_((S.posts||[]).slice());
    if(!all.length){
      list.innerHTML = '<div class="note">No posts yet.</div>';
      if(pager) pager.innerHTML = '';
      return;
    }

    // Pagination
    const pageSize = Math.max(1, Number(S.pageSize||15));
    const total = all.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    S.page = Math.max(1, Math.min(Number(S.page||1), totalPages));
    const start = (S.page - 1) * pageSize;
    const end = start + pageSize;
    const pagePosts = all.slice(start, end);

    // Header row
    if(header){
      header.innerHTML = '<div class="slbLibListHeaderRow">' +
        '<div>Post Title</div>' +
        '<div>Created by</div>' +
        '<div>Last Updated</div>' +
      '</div>';
    }

    pagePosts.forEach(p => {
      const div = document.createElement('div');
      div.className = 'slbLibPostCard';
      div.dataset.postId = p.postId;

      const title = esc(p.title || '(No title)');
      const titleBadges = (p.__optimistic ? ' <span class="slbLibBadge" style="opacity:.75;">Posting...</span>' : '') +
        (p.isPinned ? ' <span class="chip on" style="font-size:11px; padding:2px 8px; vertical-align:middle;">Pinned</span>' : '');

      const createdBy = esc(String(p.author||'').trim());
      const createdAt = fmtLocalDateShort(p.createdAt || p.updatedAt || '');
      const createdMeta = (createdBy + ' • ' + esc(createdAt||'' )).trim();

      const act = computeLastActivityForList_(p);
      const who = esc(String(act.by||'').trim());
      const when = esc(fmtLocalStamp(act.at));
      const updatedMeta = (who + ' • ' + when).trim();

      div.innerHTML = `
        <div class="slbLibRow">
          <div class="slbLibColTitle">
            <div class="slbLibTitle">${title}${titleBadges}</div>
          </div>
          <div class="slbLibColCreated slbLibColMeta">${createdMeta}</div>
          <div class="slbLibColUpdated slbLibColMeta">${updatedMeta}</div>
        </div>
      `;
      list.appendChild(div);
    });

    // Pager
    if(pager){
      const disPrev = (S.page <= 1);
      const disNext = (S.page >= totalPages);
      pager.innerHTML = `
        <button class="btn" type="button" data-page="prev" ${disPrev?'disabled':''}>Prev</button>
        <span class="badge" style="min-width:120px;text-align:center;">Page ${S.page} / ${totalPages}</span>
        <button class="btn" type="button" data-page="next" ${disNext?'disabled':''}>Next</button>
      `;
    }

    try{ _libWarmListTopDetails(); }catch(_e){}

    // Restore anchor position
    if(pinScroll && anchorId){
      try{
        const sel = '[data-post-id="' + CSS_ESCAPE(anchorId) + '"]';
        const el = list.querySelector(sel);
        if(el){
          const newTop = el.getBoundingClientRect().top;
          const delta = newTop - anchorTop;
          if(Math.abs(delta) > 2){ window.scrollBy(0, delta); }
        }
      }catch(_e2){}
    }
  }


  function renderPostDetail(data){
    const box = $("#slbLibDetail");
    if(!box) return;
    const post = data.post;
    const comments = data.comments || [];
    const cs = currentCallsign();

    const canEdit = S.canAdmin || (String(post.author||"").toUpperCase() === cs);
    const canDelete = S.canAdmin || S.canMod || canEdit;

    const postId = String(post && post.postId || "");

    // Comment paging state
    const pageSize = Number(S.commentPageSize || 10) || 10;
    const _totalCommentPages_ = () => Math.max(1, Math.ceil((comments.length || 0) / pageSize));
    let cpage = Math.max(1, Math.min(_totalCommentPages_(), Number(S.commentPage[postId]) || 1));
    S.commentPage[postId] = cpage;

    const actions = `
      <div class="slbLibTop slbLibDetailActions" style="margin-top:0;display:grid;grid-template-columns:auto 1fr auto;align-items:center;width:100%;">
        <div class="slbLibActionLeft">
          <button class="btn" id="slbLibBackBtn" type="button">Back</button>
          ${canEdit ? '<button class="btn" id="slbLibEditBtn" type="button">Edit</button>' : ''}
          ${S.canAdmin ? (post.isPinned
            ? '<button class="btn slbIconBtn" id="slbLibUnpinBtn" type="button" title="Unpin"><span class="slbIco">📍</span></button>'
            : '<button class="btn slbIconBtn" id="slbLibPinBtn" type="button" title="Pin"><span class="slbIco">📌</span></button>'
          ) : ''}
        </div>
        <div class="slbFlexSpacer" aria-hidden="true"></div>
        <div class="slbLibActionRight">
          ${(S.canAdmin || S.canMod) ? '<button class="btn orange" id="slbLibSendToBtn" type="button">Send To</button>' : ''}
          ${canDelete ? '<button class="btn slbXNoSkin" id="slbLibDeleteBtn" type="button" title="Delete" aria-label="Delete">✕</button>' : ''}
        </div>
      </div>
    `;

    const rich = (post && post.bodyRich) ? sanitizeRichHtml(post.bodyRich) : "";
    const bodyBlock = rich
      ? `<div style="margin-top:10px;" class="slbRichPost">${rich}</div>`
      : `<div style="margin-top:10px; white-space:pre-wrap;">${esc(post.body||"")}</div>`;

    function _stripHtmlToText_(html){
      try{
        const d = document.createElement('div');
        d.innerHTML = String(html||"");
        return String(d.textContent || d.innerText || "");
      }catch(_e){
        return String(html||"").replace(/<[^>]*>/g,' ');
      }
    }

    function _commentBodyHtml_(c){
      const br = String((c && c.bodyRich) || "").trim();
      if(br){
        const s = sanitizeRichHtml(br);
        return `<div class="slbRichPost">${s}</div>`;
      }
      return `<div style="white-space:pre-wrap;">${esc((c && c.body) || "")}</div>`;
    }

    function _renderCommentSlice_(){
      const start = (cpage - 1) * pageSize;
      const slice = (comments || []).slice(start, start + pageSize);
      if(!slice.length) return '<div class="note">No comments.</div>';
      return slice.map(c => `
        <div class="slbLibCommentCard" data-comment-id="${esc(c.commentId||"")}">
          <div class="slbLibCommentMetaRow">
            <div class="slbLibMeta">${esc(c.author||"")} • ${esc(fmtTime(c.createdAt))}</div>
            <div class="slbLibCommentActions">
              ${(S.canAdmin || S.canMod) ? `<button class=\"btn slbXNoSkin\" data-del-comment=\"${esc(c.commentId)}\" type=\"button\" title=\"Delete\" aria-label=\"Delete\">✕</button>` : ``}
            </div>
          </div>
          <div class="slbLibCommentBody">${_commentBodyHtml_(c)}</div>
        </div>
      `).join("");
    }

    function _renderCommentPager_(){
      const tp = _totalCommentPages_();
      if((comments || []).length <= pageSize) return '';
      const disPrev = (cpage <= 1);
      const disNext = (cpage >= tp);
      return `
        <div class="slbLibCommentPager">
          <button class="btn" type="button" data-cpage="prev" ${disPrev?'disabled':''}>Prev</button>
          <span class="badge" style="min-width:120px;text-align:center;">Page ${cpage} / ${tp}</span>
          <button class="btn" type="button" data-cpage="next" ${disNext?'disabled':''}>Next</button>
        </div>
      `;
    }

    const commentToolbarHtml = `
      <div class="slbWysToolbar" id="slbLibCommentWysToolbar">
        <div class="slbWysRow">
          <div class="slbWysGroup">
            <select class="inp" id="slbLibCommentHeading" style="width:160px;">
              <option value="p">Paragraph</option>
              <option value="h1">H1</option>
              <option value="h2">H2</option>
              <option value="h3">H3</option>
              <option value="h4">H4</option>
            </select>
            <select class="inp" id="slbLibCommentWysSize" style="width:110px;">
              <option value="12">12</option>
              <option value="14" selected>14</option>
              <option value="16">16</option>
              <option value="18">18</option>
              <option value="20">20</option>
              <option value="24">24</option>
              <option value="28">28</option>
              <option value="32">32</option>
              <option value="40">40</option>
            </select>
          </div>

          <div class="slbWysGroup">
            <button class="btn soft mini" type="button" data-wcmd="bold"><b>B</b></button>
            <button class="btn soft mini" type="button" data-wcmd="italic"><i>I</i></button>
            <button class="btn soft mini" type="button" data-wcmd="underline"><u>U</u></button>
            <button class="btn soft mini" type="button" data-wcmd="strikeThrough"><s>S</s></button>
          </div>

          <div class="slbWysGroup">
            <button class="btn soft mini" type="button" data-wcmd="insertUnorderedList" title="Bullet list">•</button>
            <button class="btn soft mini" type="button" data-wcmd="insertOrderedList" title="Number list">1.</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyLeft" title="Align left">⟸</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyCenter" title="Align center">⇔</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyRight" title="Align right">⟹</button>
            <button class="btn soft mini" type="button" data-wcmd="justifyFull" title="Justify">☰</button>
            <button class="btn soft mini" type="button" data-wcmd="quote" title="Quote">❝</button>
          </div>
        </div>

        <div class="slbWysRow">
          <div class="slbWysGroup">
            <button class="btn square mini" type="button" data-wcolor="#ef4444" style="background:#ef4444;color:#fff;">A</button>
            <button class="btn square mini" type="button" data-wcolor="#f59e0b" style="background:#f59e0b;color:#fff;">A</button>
            <button class="btn square mini" type="button" data-wcolor="#10b981" style="background:#10b981;color:#fff;">A</button>
            <button class="btn square mini" type="button" data-wcolor="#3b82f6" style="background:#3b82f6;color:#fff;">A</button>
            <button class="btn square mini" type="button" data-wcolor="#7c3aed" style="background:#7c3aed;color:#fff;">A</button>
            <span class="slbWysColorBtn slbWysColorBtn--text" title="Custom text color">
              <span class="slbWysColorQ">?</span>
            <input type="color" id="slbLibCommentWysColor" class="inp slbWysColorInput" />
            </span>
          </div>

          <div class="slbWysGroup">
            <button class="btn square mini" type="button" data-wbg="#fde68a" style="background:#fde68a;color:#000;">HL</button>
            <button class="btn square mini" type="button" data-wbg="#bbf7d0" style="background:#bbf7d0;color:#000;">HL</button>
            <button class="btn square mini" type="button" data-wbg="#bfdbfe" style="background:#bfdbfe;color:#000;">HL</button>
            <button class="btn square mini" type="button" data-wbg="#fecaca" style="background:#fecaca;color:#000;">HL</button>
            <button class="btn square mini" type="button" data-wbg="#f3e8ff" style="background:#f3e8ff;color:#000;">HL</button>
            <span class="slbWysColorBtn slbWysColorBtn--hl" title="Custom highlight">
              <span class="slbWysColorQ">?</span>
              <input type="color" id="slbLibCommentWysHl" class="inp slbWysColorInput" />
            </span>
          </div>

          <div class="slbWysGroup slbEmojiWrap">
            <button class="btn soft mini" type="button" data-wcmd="emoji" title="Emojis">🙂</button>
            <div class="slbEmojiPanel hidden">
              <button class="slbEmojiItem" type="button" data-emoji="😀">😀</button>
              <button class="slbEmojiItem" type="button" data-emoji="😁">😁</button>
              <button class="slbEmojiItem" type="button" data-emoji="😄">😄</button>
              <button class="slbEmojiItem" type="button" data-emoji="😂">😂</button>
              <button class="slbEmojiItem" type="button" data-emoji="🤣">🤣</button>
              <button class="slbEmojiItem" type="button" data-emoji="🙂">🙂</button>
              <button class="slbEmojiItem" type="button" data-emoji="😉">😉</button>
              <button class="slbEmojiItem" type="button" data-emoji="😎">😎</button>
              <button class="slbEmojiItem" type="button" data-emoji="🤔">🤔</button>
              <button class="slbEmojiItem" type="button" data-emoji="😮">😮</button>
              <button class="slbEmojiItem" type="button" data-emoji="😭">😭</button>
              <button class="slbEmojiItem" type="button" data-emoji="😡">😡</button>
              <button class="slbEmojiItem" type="button" data-emoji="👍">👍</button>
              <button class="slbEmojiItem" type="button" data-emoji="👎">👎</button>
              <button class="slbEmojiItem" type="button" data-emoji="🙏">🙏</button>
              <button class="slbEmojiItem" type="button" data-emoji="✨">✨</button>
              <button class="slbEmojiItem" type="button" data-emoji="⚡">⚡</button>
              <button class="slbEmojiItem" type="button" data-emoji="❤️">❤️</button>
              <button class="slbEmojiItem" type="button" data-emoji="💜">💜</button>
              <button class="slbEmojiItem" type="button" data-emoji="🔥">🔥</button>
              <button class="slbEmojiItem" type="button" data-emoji="🌙">🌙</button>
              <button class="slbEmojiItem" type="button" data-emoji="⭐">⭐</button>
              <button class="slbEmojiItem" type="button" data-emoji="✅">✅</button>
              <button class="slbEmojiItem" type="button" data-emoji="❗">❗</button>
              <button class="slbEmojiItem" type="button" data-emoji="💡">💡</button>
              <button class="slbEmojiItem" type="button" data-emoji="📌">📌</button>
              <button class="slbEmojiItem" type="button" data-emoji="🧧">🧧</button>
              <button class="slbEmojiItem" type="button" data-emoji="🐉">🐉</button>
              <button class="slbEmojiItem" type="button" data-emoji="☯️">☯️</button>
              <button class="slbEmojiItem" type="button" data-emoji="🌀">🌀</button>
              <button class="slbEmojiItem" type="button" data-emoji="🛡️">🛡️</button>
              <button class="slbEmojiItem" type="button" data-emoji="🎯">🎯</button>
              <button class="slbEmojiItem" type="button" data-emoji="📣">📣</button>
              <button class="slbEmojiItem" type="button" data-emoji="🤝">🤝</button>
              <button class="slbEmojiItem" type="button" data-emoji="🟠">🟠</button>
              <button class="slbEmojiItem" type="button" data-emoji="⚔️">⚔️</button>
            </div>
          </div>

          <div class="slbWysGroup slbWysEnd">
            <button class="btn soft mini" type="button" data-wcmd="createLink" title="Link">🔗</button>
            <button class="btn soft mini" type="button" data-wcmd="insertImage" title="Image">🖼️</button>
            <button class="btn soft mini" type="button" data-wcmd="yt" title="YouTube">▶️</button>
            <button class="btn soft mini square" type="button" data-wcmd="removeFormat" title="Clear formatting">✕</button>
          </div>
        </div>
      </div>
    `;

    box.innerHTML = `
      <div class="slbLibDetailHead">
        ${actions}
        <div class="slbLibDetailTitle">${esc(post.title||"")}</div>
        <div class="slbLibMeta">${esc(catNameById(post.catId))} • ${esc(post.author||"")} • ${esc(fmtTime(post.updatedAt||post.createdAt))} ${post.tags ? " • "+esc(post.tags) : ""}</div>
      </div>

      <div class="slbLibDetailBody">
        ${bodyBlock}
      </div>

      <div class="slbLibCommentsWrap">
        <div class="slbLibCommentsHeader">
          <div class="slbLibCommentsTitle">Comments</div>
        </div>
        <div id="slbLibCommentsList">${_renderCommentSlice_()}</div>
        <div id="slbLibCommentsPager">${_renderCommentPager_()}</div>

        <div class="slbLibCommentComposer">
          <div class="slbStdEditor" data-slbeditor="v1" id="slbLibCommentStdEditor" data-slbeditor-height="220">
            ${commentToolbarHtml}
            <div class="richEditor slbStdArea slbLibCommentRich" id="slbLibCommentRich" contenteditable="true" spellcheck="true"></div>
          </div>
          <div class="slbLibTop" style="margin-top:8px;">
            <button class="btn orange" id="slbLibCommentAdd" type="button">Add</button>
	            ${(S.canAdmin || S.canMod) ? `<span style="margin-left:10px;display:inline-flex;align-items:center;gap:6px;vertical-align:middle;">
	              <input type="checkbox" id="slbLibCommentNotifyAll" />
	              <label for="slbLibCommentNotifyAll" style="margin:0;cursor:pointer;user-select:none;">Notify everyone by email</label>
	            </span>` : ``}
            <div class="note" id="slbLibDetailMsg"></div>
          </div>
        </div>
      </div>
    `;

    // Auto-embed media links inside the rendered post + comments (frontend only)
    try{
      const bodyEl = box.querySelector('.slbLibDetailBody');
      if(bodyEl) _slbAutoEmbed_(bodyEl);
      const cList = box.querySelector('#slbLibCommentsList');
      if(cList) _slbAutoEmbed_(cList);
    }catch(_e){}

    function _updateCommentsDom_(){
      const listEl = $("#slbLibCommentsList");
      const pagerEl = $("#slbLibCommentsPager");
      if(listEl) listEl.innerHTML = _renderCommentSlice_();
      if(pagerEl) pagerEl.innerHTML = _renderCommentPager_();
      try{ if(listEl) _slbAutoEmbed_(listEl); }catch(_e){}
    }

    // Comment pager + delete (event delegation)
    if(!box.__slbDetailBound){
      box.__slbDetailBound = true;
      box.addEventListener('click', async (ev) => {
        const t = ev.target;
        if(!t || !t.closest) return;

        const pg = t.closest('[data-cpage]');
        if(pg){
          const dir = String(pg.getAttribute('data-cpage')||'');
          if(dir === 'prev') cpage = Math.max(1, cpage - 1);
          if(dir === 'next') cpage = Math.min(_totalCommentPages_(), cpage + 1);
          S.commentPage[postId] = cpage;
          _updateCommentsDom_();
          return;
        }

        const del = t.closest('[data-del-comment]');
        if(del){
          const cid = String(del.getAttribute('data-del-comment')||'');
          if(!cid) return;
          if(!confirm('Delete this comment?')) return;

          // optimistic remove from local array
          const idx = (comments||[]).findIndex(x => String(x && x.commentId || '') === cid);
          let backup = null;
          if(idx >= 0){
            backup = comments[idx];
            comments.splice(idx, 1);
            // adjust paging
            const newTotal = Math.max(1, Math.ceil((comments.length||0)/pageSize));
            cpage = Math.max(1, Math.min(newTotal, cpage));
            S.commentPage[postId] = cpage;
            _updateCommentsDom_();
          }
          try{
            await rpcAny('LIB_COMMENT_DELETE', ['libraryCommentDelete','libCommentDelete'], { commentId: cid });
            const msg = $("#slbLibDetailMsg");
            if(msg) msg.textContent = '';
          }catch(e){
            // restore
            if(backup){ comments.splice(idx>=0?idx:0, 0, backup); }
            _updateCommentsDom_();
            const msg = $("#slbLibDetailMsg");
            if(msg) msg.textContent = String(e && (e.message||e) || 'Error');
          }
          return;
        }
      });
    }

    // Wire comment WYS editor
    (function wireCommentEditor_(){
      const toolbar = $("#slbLibCommentWysToolbar");
      const editor = $("#slbLibCommentRich");
      if(!toolbar || !editor) return;
      if(toolbar.__slbWired) return;
      toolbar.__slbWired = true;

      let savedRange = null;
      function getSelRange(){
        const sel = window.getSelection && window.getSelection();
        if(!sel || sel.rangeCount < 1) return null;
        const r = sel.getRangeAt(0);
        if(!r) return null;
        try{
          const c = r.commonAncestorContainer;
          if(!c) return null;
          const node = (c.nodeType === 1) ? c : c.parentNode;
          if(node && editor.contains(node)) return r;
        }catch(_e){}
        return null;
      }
      function save(){
        const r = getSelRange();
        if(r) savedRange = r.cloneRange();
      }
      function restore(){
        if(!savedRange) return;
        try{
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(savedRange);
        }catch(_e){}
      }
      function focus(){
        try{ editor.focus(); }catch(_e){}
      }
      function _alignAttrToStyle_(root){
        try{
          const els = root.querySelectorAll('[align]');
          els.forEach(el => {
            const a = String(el.getAttribute('align')||'').trim().toLowerCase();
            if(!a) return;
            el.removeAttribute('align');
            let v = '';
            if(a === 'left') v = 'left';
            else if(a === 'center') v = 'center';
            else if(a === 'right') v = 'right';
            else if(a === 'justify') v = 'justify';
            if(!v) return;
            const cur = String(el.getAttribute('style')||'');
            const cleaned = cur
              .split(';')
              .map(x => x.trim())
              .filter(x => x && !/^text-align\s*:/i.test(x))
              .join(';');
            const next = (cleaned ? cleaned + ';' : '') + 'text-align:' + v + ';';
            el.setAttribute('style', next);
          });
        }catch(_e){}
      }

      function exec(cmd, val){
        try{ document.execCommand(cmd, false, val); }catch(_e){}
        // Some browsers use align="..." for justify commands; convert to style so our sanitizer keeps it.
        _alignAttrToStyle_(editor);
        try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
        save();
      }

      function insertStyledSpan(style){
        const r = getSelRange() || savedRange;
        if(!r) return false;
        try{
          if(r.collapsed) return false;
          const span = document.createElement('span');
          span.setAttribute('style', style);
          span.appendChild(r.extractContents());
          r.insertNode(span);
          // move caret to end
          r.setStartAfter(span); r.collapse(true);
          const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
          return true;
        }catch(_e){ return false; }
      }

      function applyTextColor_(c){
        if(!insertStyledSpan('color:'+c+';')) exec('foreColor', c);
      }
      function applyHighlight_(c){
        if(!insertStyledSpan('background-color:'+c+';')) exec('hiliteColor', c);
      }

      function wrapSelectionLink_(url){
        const r = getSelRange() || savedRange;
        if(!r || r.collapsed) return false;
        try{
          const a = document.createElement('a');
          a.setAttribute('href', url);
          a.setAttribute('target','_blank');
          a.setAttribute('rel','noopener noreferrer');
          a.appendChild(r.extractContents());
          r.insertNode(a);
          r.setStartAfter(a); r.collapse(true);
          const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
          return true;
        }catch(_e){ return false; }
      }

      function insertImageAtCaret_(url){
        const r = getSelRange() || savedRange;
        if(!r) return false;
        try{
          const img = document.createElement('img');
          img.setAttribute('src', url);
          img.setAttribute('alt', '');
          r.insertNode(img);
          r.setStartAfter(img); r.collapse(true);
          const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
          return true;
        }catch(_e){ return false; }
      }

      function insertYoutube_(url){
        url = String(url||'').trim();
        if(!url) return;

        function ytInfo_(u){
          try{
            if(!/^https?:\/\//i.test(u)) u = 'https://' + u;
            const x = new URL(u);
            const host = String(x.hostname||'').toLowerCase();
            const listId = x.searchParams.get('list') || '';

            let vid = x.searchParams.get('v') || '';
            if(!vid && host.includes('youtu.be')){
              const p = String(x.pathname||'').replace(/^\//,'');
              vid = (p.split(/[?&#/]/)[0] || '');
            }
            if(!vid){
              const m = String(x.pathname||'').match(/\/(embed|shorts)\/([A-Za-z0-9_-]{6,})/i);
              if(m && m[2]) vid = m[2];
            }
            return { vid: vid||'', listId: listId||'' };
          }catch(_e){}
          return { vid:'', listId:'' };
        }

        const info = ytInfo_(url);

        // Playlist support (works even when it is only a playlist link)
        if(info.listId && /^[A-Za-z0-9_-]{6,}$/.test(info.listId)){
          const src = safeUrl('https://www.youtube.com/embed/videoseries?list=' + encodeURIComponent(info.listId));
          if(!src) return;
          const html = '<div class="slbYtEmbed"><iframe src="' + src + '" title="YouTube playlist" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>';
          try{
            const r = getSelRange() || savedRange;
            if(r){
              const tmp = document.createElement('div');
              tmp.innerHTML = html;
              const node = tmp.firstChild;
              r.insertNode(node);
              r.setStartAfter(node); r.collapse(true);
              const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
            }else{
              restore(); focus();
              exec('insertHTML', html);
            }
            try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
            save();
          }catch(_e){
            const su = safeUrl(url);
            if(su && !wrapSelectionLink_(su)){
              restore(); focus(); exec('insertText', su);
            }
          }
          return;
        }

        // Regular single video
        const id = info.vid;
        if(!id || !/^[A-Za-z0-9_-]{6,}$/.test(id)){
          // Fallback: insert as link if we can't parse
          const su = safeUrl(url);
          if(!su) return;
          if(!wrapSelectionLink_(su)){
            restore(); focus();
            exec('insertText', su);
          }
          return;
        }

        const src = safeUrl('https://www.youtube.com/embed/' + encodeURIComponent(id) + '?rel=0');
        if(!src) return;

        const html = '<div class="slbYtEmbed"><iframe src="' + src + '" title="YouTube video" frameborder="0" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div>';
        try{
          const r = getSelRange() || savedRange;
          if(r){
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const node = tmp.firstChild;
            r.insertNode(node);
            r.setStartAfter(node); r.collapse(true);
            const sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r);
          }else{
            restore(); focus();
            exec('insertHTML', html);
          }
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
        }catch(_e){
          // Last fallback: link
          const su2 = safeUrl(url);
          if(su2 && !wrapSelectionLink_(su2)){
            restore(); focus();
            exec('insertText', su2);
          }
        }
      }


      function closeEmoji_(){
        try{
          const p = toolbar.querySelector('.slbEmojiPanel');
          if(p) p.classList.add('hidden');
        }catch(_e){}
      }
      function toggleEmoji_(){
        const p = toolbar.querySelector('.slbEmojiPanel');
        if(!p) return;
        const wasOpen = !p.classList.contains('hidden');
        closeEmoji_();
        if(wasOpen) return;
        p.classList.remove('hidden');
      }

      editor.addEventListener('mouseup', save);
      editor.addEventListener('keyup', save);
      editor.addEventListener('touchend', save);
      editor.addEventListener('focus', save);

      // Sanitize on paste: plain text only
      editor.addEventListener('paste', (e) => {
        e.preventDefault();
        let t = '';
        try{ t = (e.clipboardData || window.clipboardData).getData('text/plain'); }catch(_e){}
        if(!t) return;
        restore(); focus();
        exec('insertText', t);
      });

      toolbar.addEventListener('mousedown', save, true);

      toolbar.addEventListener('click', (ev) => {
        const btn = ev.target.closest('button');
        if(!btn) return;
        const emoji = btn.getAttribute('data-emoji');
        const wcmd = btn.getAttribute('data-wcmd');
        const wcolor = btn.getAttribute('data-wcolor');
        const wbg = btn.getAttribute('data-wbg');

        if(emoji){
          restore(); focus(); closeEmoji_();
          exec('insertText', String(emoji));
          return;
        }
        if(String(wcmd||'') === 'emoji'){ toggleEmoji_(); return; }

        if(wcolor){ restore(); focus(); applyTextColor_(wcolor); return; }
        if(wbg){ restore(); focus(); applyHighlight_(wbg); return; }

        if(!wcmd) return;
        const cmd = String(wcmd||'');
        restore(); focus(); closeEmoji_();

        if(cmd === 'bold'){ if(!insertStyledSpan('font-weight:bold;')) exec('bold'); return; }
        if(cmd === 'italic'){ if(!insertStyledSpan('font-style:italic;')) exec('italic'); return; }
        if(cmd === 'underline'){ if(!insertStyledSpan('text-decoration:underline;')) exec('underline'); return; }
        if(cmd === 'strikeThrough'){ if(!insertStyledSpan('text-decoration:line-through;')) exec('strikeThrough'); return; }
        if(cmd === 'removeFormat'){ exec('removeFormat'); return; }

        if(cmd === 'createLink'){
          let u = prompt('Link URL (https://...)') || '';
          u = String(u).trim();
          if(u && !/^https?:\/\//i.test(u)) u = 'https://' + u;
          const su = safeUrl(u);
          if(!su) return;
          if(!wrapSelectionLink_(su)) exec('createLink', su);
          return;
        }
        if(cmd === 'insertImage'){
          let u = prompt('Image URL (https://...)') || '';
          u = String(u).trim();
          const su = safeUrl(u);
          if(!su) return;
          if(!insertImageAtCaret_(su)) exec('insertImage', su);
          return;
        }
        if(cmd === 'yt'){
          let u = prompt('YouTube URL (https://...)') || '';
          u = String(u).trim();
          if(!u) return;
          insertYoutube_(u);
          return;
        }

        if(cmd === 'quote'){
          try{ document.execCommand('formatBlock', false, 'BLOCKQUOTE'); }catch(_e){}
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
          return;
        }

        exec(cmd);
      });

      const color = $("#slbLibCommentWysColor");
      if(color){
        color.addEventListener('mousedown', save);
        color.addEventListener('change', () => { restore(); focus(); const c = String(color.value||'').trim(); if(c) applyTextColor_(c); });
      }
      const hl = $("#slbLibCommentWysHl");
      if(hl){
        hl.addEventListener('mousedown', save);
        hl.addEventListener('change', () => { restore(); focus(); const c = String(hl.value||'').trim(); if(c) applyHighlight_(c); });
      }
      const heading = $("#slbLibCommentHeading");
      if(heading){
        heading.addEventListener('mousedown', save);
        heading.addEventListener('change', () => {
          restore(); focus();
          const v = String(heading.value||'').trim().toLowerCase();
          if(!v) return;
          const tag = (v === 'p') ? 'P' : v.toUpperCase();
          try{ document.execCommand('formatBlock', false, tag); }catch(_e){}
          try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e2){}
          save();
        });
      }
      const size = $("#slbLibCommentWysSize");
      if(size){
        size.addEventListener('mousedown', save);
        size.addEventListener('change', () => {
          restore(); focus();
          const n = Number(String(size.value||'').trim());
          if(!n) return;
          const px = Math.max(8, Math.min(48, Math.round(n)));
          if(!insertStyledSpan('font-size:' + px + 'px;')){
            try{ document.execCommand('styleWithCSS', false, true); }catch(_e){}
            try{ document.execCommand('fontSize', false, '7'); }catch(_e2){}
            try{ editor.innerHTML = sanitizeRichHtml(editor.innerHTML); }catch(_e3){}
          }
          save();
        });
      }

      // Close emoji panels in the detail view on outside click (capture)
      if(!window.__SLB_LIB_DETAIL_EMOJI_DOC){
        window.__SLB_LIB_DETAIL_EMOJI_DOC = true;
        document.addEventListener('click', (e) => {
          try{
            const d = document.getElementById('slbLibDetail');
            if(!d) return;
            const inEmoji = e.target && e.target.closest && e.target.closest('.slbEmojiWrap');
            if(inEmoji) return;
            d.querySelectorAll('.slbEmojiPanel').forEach(p => p.classList.add('hidden'));
          }catch(_e){}
        }, true);
      }
    })();

    // Add comment (rich)
    const addBtn = $("#slbLibCommentAdd");
    if(addBtn){
      addBtn.addEventListener('click', async () => {
        const msg = $("#slbLibDetailMsg");
        if(msg) msg.textContent = '';

        const ed = $("#slbLibCommentRich");
        if(!ed) return;
        const rawHtml = String(ed.innerHTML || '');
        const safeHtml = sanitizeRichHtml(rawHtml);
        const plain = _stripHtmlToText_(safeHtml).replace(/\s+/g,' ').trim();
        // Treat images/links as content even if plain text is empty
        const hasNonText = /<(img|a|iframe)\b/i.test(safeHtml);
        if(!plain && !hasNonText){
          if(msg) msg.textContent = 'Comment is empty.';
          return;
        }

        // optimistic insert at top, reset to page 1
        const tmpId = makeTmpId('c');
        const now = nowIso();
        const csNow = currentCallsign();
        const newC = { commentId: tmpId, postId: postId, body: plain, bodyRich: safeHtml, author: csNow, createdAt: now };
        comments.unshift(newC);
        cpage = 1;
        S.commentPage[postId] = 1;
        _updateCommentsDom_();
        ed.innerHTML = '';
        addBtn.disabled = true;
        try{
          const cNotifyAll = !!((S.canAdmin || S.canMod) && (()=>{ try{ return !!$("#slbLibCommentNotifyAll") && !!$("#slbLibCommentNotifyAll").checked; }catch(_e){ return false; } })());
          const cBaseUrl = (()=>{ try{ return (location.origin + location.pathname); }catch(_e){ return ""; } })();
          const out = await rpcAny('LIB_COMMENT_ADD', ['libraryCommentAdd','libCommentAdd'], { postId, body: plain, bodyRich: safeHtml, notifyAll: cNotifyAll ? 1 : 0, baseUrl: cBaseUrl || "" });
          const realId = String((out && (out.commentId || (out.comment && out.comment.commentId))) || tmpId);
          newC.commentId = realId;
          _updateCommentsDom_();
        }catch(e){
          // remove optimistic
          const i = comments.findIndex(x => String(x && x.commentId || '') === tmpId);
          if(i >= 0) comments.splice(i, 1);
          _updateCommentsDom_();
          if(msg) msg.textContent = String(e && (e.message||e) || 'Error');
        }finally{
          addBtn.disabled = false;
        }
      });
    }

const back = $("#slbLibBackBtn");
    if(back) back.addEventListener("click", () => {
      S.selectedPostId = "";
      try{ window.__SLB_LIB_SELECTED_POSTID = ""; }catch(_e0){}
      setView("list");
	  try{ _libSetDeepLink_(""); }catch(_e){}
    });


    const linkBtn = $("#slbLibLinkBtn");
    if(linkBtn){
      linkBtn.addEventListener("click", async () => {
        try{
          const pid = String(postId||"").trim();
          if(!pid) return;
          const url = (location.origin + location.pathname + "#tab=myCabin&cabin=library&postId=" + encodeURIComponent(pid));
          let ok = false;
          try{
            if(window.SLB_route && typeof window.SLB_route.copy === 'function'){
              ok = await window.SLB_route.copy(url);
            }else if(navigator.clipboard && navigator.clipboard.writeText){
              await navigator.clipboard.writeText(url); ok = true;
            }
          }catch(_e){}
          try{
            const msg = $("#slbLibDetailMsg");
            if(msg){
              msg.textContent = ok ? "Link copied." : url;
              if(ok){ setTimeout(()=>{ try{ if(msg.textContent==="Link copied.") msg.textContent=""; }catch(_e2){} }, 1600); }
            }
          }catch(_e3){}
        }catch(_e4){}
      });
    }


    const sendToBtn = $("#slbLibSendToBtn");
    if(sendToBtn){
      sendToBtn.addEventListener("click", () => {
        try{
          libSendToOpen_(post).catch(()=>{});
        }catch(_e){}
      });
    }

    const delBtn = $("#slbLibDeleteBtn");
    if(delBtn){
      delBtn.addEventListener("click", async () => {
        if(!confirm("Delete this post?")) return;
        try{
          const doomed = String(post.postId||"");
          delBtn.disabled = true;
          try{ $("#slbLibDetailMsg").textContent = "Deleting..."; }catch(_e){}

          // Do the server delete first. If it fails, we stay on the detail view
          // so the error message is visible (no more "disappear then bounce back").
          await rpc("libraryPostDelete", { postId: doomed });

          // Now update UI
          S.posts = removePostFromArray(S.posts, doomed);
          renderList();
          S.selectedPostId = "";
          setView("list");
          try{ _libSetDeepLink_(""); }catch(_e2){}
        }catch(e){
          $("#slbLibDetailMsg").textContent = String(e.message || e);
        }finally{
          try{ delBtn.disabled = false; }catch(_e3){}
        }
      });
    }

    const editBtn = $("#slbLibEditBtn");
    if(editBtn){
      editBtn.addEventListener("click", () => {
        startEdit(post);
      });
    }

    const pinBtn = $("#slbLibPinBtn");
    if(pinBtn){
      pinBtn.addEventListener("click", async () => {
        try{ await rpc("libraryPostPin", { postId: post.postId, on: true }); await openPost(post.postId); await reloadListOnly(); }catch(e){ $("#slbLibDetailMsg").textContent = String(e.message||e); }
      });
    }
    const unpinBtn = $("#slbLibUnpinBtn");
    if(unpinBtn){
      unpinBtn.addEventListener("click", async () => {
        try{ await rpc("libraryPostPin", { postId: post.postId, on: false }); await openPost(post.postId); await reloadListOnly(); }catch(e){ $("#slbLibDetailMsg").textContent = String(e.message||e); }
      });
    }
    const archBtn = $("#slbLibArchiveBtn");
    if(archBtn){
      archBtn.addEventListener("click", async () => {
        try{ await rpc("libraryPostArchive", { postId: post.postId, on: true }); S.selectedPostId=""; setView("list"); await reload(); }catch(e){ $("#slbLibDetailMsg").textContent = String(e.message||e); }
      });
    }
    const unarchBtn = $("#slbLibUnarchiveBtn");
    if(unarchBtn){
      unarchBtn.addEventListener("click", async () => {
        try{ await rpc("libraryPostArchive", { postId: post.postId, on: false }); await openPost(post.postId); await reloadListOnly(); }catch(e){ $("#slbLibDetailMsg").textContent = String(e.message||e); }
      });
    }

    show(box);
    box.scrollIntoView({behavior:"smooth", block:"start"});
  }

  function startNew(){
    S.editingPostId = "";
    $("#slbLibTitle").value = "";
    $("#slbLibTags").value = "";
$("#slbLibBody").value = "";
    clearRichEditor();
    $("#slbLibAccess").value = "";
    $("#slbLibComposerMsg").textContent = "";
    try{ $("#slbLibNotifyAll").checked = false; }catch(_e){}
    setView("list");
    show($("#slbLibComposer"));
    hide($("#slbLibDetail"));
    $("#slbLibTitle").focus();
  }

  function startEdit(post){
    S.editingPostId = post.postId;
    $("#slbLibTitle").value = post.title || "";
    $("#slbLibTags").value = post.tags || "";
$("#slbLibBody").value = post.body || "";
    if(post.bodyRich){
      setRichEditorHtml(post.bodyRich);
    }else{
      // fallback: plain -> simple HTML
      const safe = esc(post.body || "").replace(/\n/g, "<br>");
      setRichEditorHtml(safe);
    }
    $("#slbLibAccess").value = post.accessGroups || "";
    const sel = $("#slbLibCat");
    if(sel) sel.value = post.catId || sel.value;
    $("#slbLibComposerMsg").textContent = "Editing post.";
    try{ $("#slbLibNotifyAll").checked = false; }catch(_e){}
    setView("list");
    show($("#slbLibComposer"));
    hide($("#slbLibDetail"));
    $("#slbLibTitle").focus();
  }

  async function submitPost(){
    const title = ($("#slbLibTitle").value || "").trim();
    const catId = ($("#slbLibCat").value || "").trim();
    const tags = ($("#slbLibTags").value || "").trim();
// Rich editor -> sanitize client-side, also send plain text for search/snippets
    const bodyRich = getRichEditorHtml();
    const body = htmlToText(bodyRich).trim();
    // Keep hidden textarea in sync (fallback / legacy)
    try{ $("#slbLibBody").value = body; }catch(_e){}
    const accessGroups = ($("#slbLibAccess").value || "").trim();

    const msg = $("#slbLibComposerMsg");
    const btn = $("#slbLibPostBtn");
    if(msg) msg.textContent = "";

    if(!title){
      if(msg) msg.textContent = "Title required.";
      return;
    }

    // Writes require a live session token (reads may still work from cache)
    // Re-hydrate token once from storage before declaring "Session expired"
    try{
      const a = getApp();
      let token = a && a.S ? (a.S.token||"") : "";
      if(!token){
        try{ token = String(sessionStorage.getItem("tyw_token")||""); }catch(_e1){}
      }
      if(!token){
        try{
          const raw = localStorage.getItem("ty_auth_v1") || "";
          if(raw){
            const j = JSON.parse(raw);
            if(j && j.token) token = String(j.token||"");
          }
        }catch(_e2){}
      }
      if(token && a && a.S && !a.S.token){
        a.S.token = token;
        try{ sessionStorage.setItem("tyw_token", token); }catch(_e3){}
      }
      if(!token){
        const t = "Session expired. Please refresh and log in again to post.";
        if(msg) msg.textContent = t;
        libErr(t);
        try{ show($("#slbLibComposer")); }catch(_e){}
        return;
      }
    }catch(_e){}
    const links = "";
const notifyAll = !!((S.canAdmin || S.canMod) && (()=>{ try{ return !!$("#slbLibNotifyAll") && !!$("#slbLibNotifyAll").checked; }catch(_e){ return false; } })());
    const baseUrl = (()=>{ try{ return (location.origin + location.pathname); }catch(_e){ return ""; } })();
    const payload = {
      postId: S.editingPostId || "",
      catId,
      title,
      tags,
      body,
      bodyRich,
      accessGroups,
      notifyAll: notifyAll ? 1 : 0,
      baseUrl: baseUrl || "",
    };

    const isEdit = !!S.editingPostId;

    // If user hasn't chosen a tab yet, auto-select the post's category (so Back shows a list).
    if(!isEdit && !S.activeCat){
      S.activeCat = String(catId||"");
      try{ renderCats(); }catch(_e){}
    }

    const cs = currentCallsign();
    const tmpId = isEdit ? String(S.editingPostId) : makeTmpId("post");
    const optimisticPost = {
      postId: tmpId,
      catId,
      title,
      tags,
      body,
      bodyRich,
      accessGroups,
      author: cs,
      createdAt: nowIso(),
      updatedAt: nowIso(),
      isPinned:false,
      isArchived:false,
      __optimistic:true,
    };

    // Optimistic UI: update list immediately (no full reload)
    if(!isEdit){
      // Only insert if current filter would show it (keep simple: show in All or matching cat when no search)
      const qNow = ($("#slbLibSearch").value || "").trim();
      const catNow = S.activeCat || "";
      const shouldShow = (!qNow) && (!!catNow) && (String(catNow) === String(catId));
      if(shouldShow){
        S.posts = [optimisticPost, ...(S.posts||[])];
        setListCache(catNow, qNow, S.posts, S.cats);
        renderList();
      }
      // show thread immediately (hide all)
      S.selectedPostId = tmpId;
      setDetailCache(tmpId, { post: optimisticPost, comments: [] });
      setView("thread");
      renderPostDetail({ post: optimisticPost, comments: [] });
    }else{
      // edit: update in-place if present
      S.posts = upsertPostInArray(S.posts, optimisticPost, tmpId);
      renderList();
      setDetailCache(tmpId, { post: optimisticPost, comments: [] });
      // stay in composer flow; we'll hide composer below
    }

    // Disable button to avoid double-submit
    let _libDelayT = null;
    const _libBusyTxt = isEdit ? "Saving..." : "Posting...";
    let _libPm = 'auto';
    try{ _libPm = String(sessionStorage.getItem('slb_progressMode') || localStorage.getItem('slb_progressMode') || 'auto').toLowerCase(); }catch(_e){}
    try{ if(_libPm==='auto'){
      const qs = String((location&&location.search)?location.search:'');
      if(qs){ const p = new URLSearchParams(qs); const dbg = p.get('slbdebug')||p.get('debug'); if(dbg==='1'||dbg==='true') _libPm='debug'; }
    }}catch(_e){}
    const _libDelay = (_libPm === 'debug') ? 0 : 2000;

    if(btn){
      btn.disabled = true;
      if(_libDelay <= 0){
        btn.textContent = _libBusyTxt;
      }else{
        _libDelayT = setTimeout(()=>{
          try{
            if(btn.disabled) btn.textContent = _libBusyTxt;
            if(msg) msg.textContent = _libBusyTxt;
          }catch(_e){}
        }, _libDelay);
      }
    }
    if(msg && _libDelay <= 0) msg.textContent = _libBusyTxt;

    try{
      const res = await rpc("libraryPostUpsert", payload);

      const realId = String((res && (res.postId || (res.post && res.post.postId))) || tmpId);
      const realPost = (res && res.post) ? Object.assign({}, res.post, { __optimistic:false }) : Object.assign({}, optimisticPost, { postId: realId, __optimistic:false });

      // Update list (replace temp)
      S.posts = upsertPostInArray(S.posts, realPost, tmpId);
      // update cache for current cat+q only (simple)
      const qNow = ($("#slbLibSearch").value || "").trim();
      const catNow = S.activeCat || "";
      if(!qNow){
        setListCache(catNow, qNow, S.posts, S.cats);
      }

      // Clear composer
      hide($("#slbLibComposer"));
      $("#slbLibComposerMsg").textContent = "";
      try{ $("#slbLibNotifyAll").checked = false; }catch(_e){}
      S.editingPostId = "";
      $("#slbLibTitle").value = "";
      $("#slbLibTags").value = "";
$("#slbLibBody").value = "";
      clearRichEditor();
      if($("#slbLibAccess")) $("#slbLibAccess").value = "";

      // Small success toast
      try{
        const a = getApp();
        if(a && typeof a.toast === 'function'){
          a.toast('ok', isEdit ? 'Saved ✅' : 'Posted ✅');
        }
      }catch(_e){}

      // Open real thread (if we were viewing temp thread)
      if(S.selectedPostId === tmpId){
        S.selectedPostId = realId;
        // fetch real content/comments in background
        await openPost(realId);
      }else if(isEdit){
        // if edited from list, refresh detail if open
        if(S.selectedPostId === realId) await openPost(realId);
      }

      if(msg) msg.textContent = "";
    }catch(e){
      const rawErr = String((e && (e.message || e)) || "Unknown error");
      const errMsg = (/Unknown action/i.test(rawErr))
        ? (rawErr + " (backend mismatch: please deploy the latest SLB backend zip)")
        : rawErr;

      // Loud, visible error so it doesn't look like it silently vanished
      libErr('Library post failed: ' + errMsg);
      // Rollback optimistic insert on failure (keep simple)
      if(!isEdit){
        S.posts = removePostFromArray(S.posts, tmpId);
        renderList();
        setView("list");
        try{ S.selectedPostId = ""; }catch(_e){}
        try{ show($("#slbLibComposer")); }catch(_e){}
        try{ hide($("#slbLibDetail")); }catch(_e){}
      }

      try{ $("#slbLibDetailMsg").textContent = errMsg; }catch(_e2){}
      if(msg) msg.textContent = errMsg;
    }finally{
      try{ if(_libDelayT) clearTimeout(_libDelayT); }catch(_e){}
      if(btn){ btn.disabled = false; btn.textContent = "Post"; }
    }
  }

  async function openPost(postId){
	  setView("thread");
	  try{ _libSetDeepLink_(postId); }catch(_e){}
	  try{ window.__SLB_LIB_SELECTED_POSTID = String(postId||""); }catch(_e2){}
    const box = $("#slbLibDetail");
    let cached = getDetailCache(postId);
    if(!cached){
      const off = getOfflineDetailIfAny(postId);
      if(off){
        try{ setDetailCache(postId, off); }catch(_e){}
        cached = { ts: Date.now(), data: off, stale: true };
      }
    }

    const seq = ++S.req.detailSeq;
    const wantId = String(postId||"");

    if(cached){
      try{ renderPostDetail(cached.data); }catch(_e){}
    }else{
      if(box){ box.innerHTML = '<div class="note">Loading...</div>'; show(box); }
    }

    try{
      const data = await rpcAny("LIB_GET", ["libraryGet","libGet"], { postId });
      setDetailCache(postId, data);
      // Ignore out-of-order responses
      if(seq !== S.req.detailSeq || String(S.selectedPostId||"") !== wantId) return;
      renderPostDetail(data);
    }catch(e){
      const box2 = $("#slbLibDetail");
      if(box2 && !cached){
        if(seq !== S.req.detailSeq || String(S.selectedPostId||"") !== wantId) return;
        box2.innerHTML = `<div class="err">Cannot open post: ${esc(e.message||e)}</div>`;
        show(box2);
      }else{
        console.warn("Library get failed:", e);
      }
    }
  }

  function _libEnableSearch(on){
    const s = $("#slbLibSearch");
    if(!s) return;
    try{ s.disabled = !on; }catch(_e){}
  }

  function _libSeedListFromAll(catId, q){
    catId = String(catId||"");
    q = String(q||"");
    if(!catId) return false;
    // already have cache?
    if(getListCache(catId, q) || getPersistList(catId, q)) return false;

    const allHit = getListCache("", "") || getPersistList("", "");
    if(!allHit || !allHit.posts) return false;

    const qq = q ? q.toLowerCase() : "";
    let posts = (allHit.posts || []).filter(p => String(p && p.catId || "") === catId);
    if(qq){
      posts = posts.filter(p => {
        const t = String(p && p.title || "").toLowerCase();
        const b = String(p && p.body || "").toLowerCase();
        const g = String(p && p.tags || "").toLowerCase();
        return t.includes(qq) || b.includes(qq) || g.includes(qq);
      });
    }
    // seed cache so reloadListOnly() can render instantly
    const cats = (S.cats && S.cats.length) ? S.cats : (allHit.cats || null);
    setListCache(catId, q, posts, cats);
    try{ if(!q) setPersistList(catId, q, posts, cats); }catch(_e){}
    return true;
  }

  async function _libPreloadAllPosts(force){
    if(!force && S._preloadAllDone) return;
    if(S._preloadAllInFlight) return;
    S._preloadAllInFlight = true;
    try{
      const data = await rpcAny("LIB_LIST_ALL", ["libraryList","libList"], { catId:"", q:"" });
      setListCache("", "", data.posts || [], data.cats || null);
      try{ setPersistList("", "", data.posts || [], data.cats || null); }catch(_e){}
      if(data.cats){ S.cats = data.cats; renderCats(); }
      S._preloadAllDone = true;
    }catch(e){
      // silent; cached UI still works
      console.warn("Library preload failed:", e);
    }finally{
      S._preloadAllInFlight = false;
    }
  }

  function _libStopBgSync(){
    if(S._bgSyncTimer){
      clearTimeout(S._bgSyncTimer);
      S._bgSyncTimer = null;
    }
  }

  function _libStartBgSync(){
    if(S._bgSyncTimer) return;
    const currentPanel = panel();
    if(!currentPanel || currentPanel.classList.contains("hidden")) return;
    // V4.9: keep the same quiet 60-second refresh cadence only while Library is
    // actually visible. Closing the Library retires the one-shot schedule.
    S._bgSyncTimer = setTimeout(() => {
      S._bgSyncTimer = null;
      const p = panel();
      if(!p || p.classList.contains("hidden")) return;
      const jobs = [];
      jobs.push(Promise.resolve(_libPreloadAllPosts(true)).catch(()=>null));
      if(S.activeCat && !S.threadMode && !S.adminMode){
        jobs.push(Promise.resolve(reloadListOnly({useCache:true})).catch(()=>null));
      }
      Promise.all(jobs).then(_libStartBgSync, _libStartBgSync);
    }, 60000);
  }

  async function reloadListOnly(opts){
    opts = opts || {};
    const q = ($("#slbLibSearch").value || "").trim();
    const catId = S.activeCat || "";

    // Tabs-only mode: do not render/fetch list until a category is chosen.
    if(!catId){
      renderCats();
      _libEnableSearch(false);
      try{ hide($("#slbLibSearchWrap")); hide($("#slbLibDivider")); hide($("#slbLibListHeader")); hide($("#slbLibList")); hide($("#slbLibPager")); }catch(_e){}
      return;
    }
    _libEnableSearch(true);

    const seq = ++S.req.listSeq;
    const qWant = q;
    const catWant = catId;

    // Fast path: render cached list immediately (snappier UI)
if(opts.useCache !== false){
  const hit = getListCache(catId, q);
  if(hit){
    if(hit.cats) S.cats = hit.cats;
    S.posts = hit.posts || [];
    renderCats();
    renderList();
  }else{
    // Persisted cache (survives reload) for the no-search list
    const phit = getPersistList(catId, q);
    if(phit){
      if(phit.cats) S.cats = phit.cats;
      S.posts = phit.posts || [];
      renderCats();
      renderList();
    }else{
      // Offline read-cache fallback (handles searched lists too)
      applyOfflineListIfAny(catId, q);
    }
  }
}

try{
      const data = await rpcAny("LIB_LIST", ["libraryList","libList"], { catId, q });
      // Always cache the response (even if user already switched)
      setListCache(catWant, qWant, data.posts || [], data.cats || null);
      try{ setPersistList(catWant, qWant, data.posts || [], data.cats || null); }catch(_e){}
      // Ignore out-of-order responses (prevents UI "jumping")
      const curQ = ($("#slbLibSearch").value || "").trim();
      const curCat = S.activeCat || "";
      if(seq !== S.req.listSeq || curQ !== qWant || String(curCat||"") !== String(catWant||"")) return;
      S.posts = data.posts || [];
      if(data.cats) S.cats = data.cats;
      renderCats();
      renderList();
    }catch(e){
      // Keep cached UI; don't hard-fail on slow backend
      console.warn("Library list load failed:", e);
      try{
        const now = Date.now();
        if(!S.req.lastErrToast || (now - S.req.lastErrToast) > 15000){
          S.req.lastErrToast = now;
          const a = getApp();
          const msg = String(e && (e.message||e) || "Error");
          if(a && a.toast) a.toast("err", "Library sync failed: " + msg);
        }
      }catch(_e){}
    }
  }

  async function reload(){
    // bootstrap + list
    // Use persisted bootstrap instantly for a fast first paint.
    try{
      const ph = getPersistBootstrap();
      if(ph && ph.data){
        const d0 = ph.data;
        S.cats = d0.cats || [];
        S.myGroups = d0.myGroups || [];
        S.canAdmin = !!d0.canAdmin;
        S.canMod = !!d0.canMod;
        renderCats();
      }
    }catch(_e){}

    let data = null;
    try{
      data = await rpcAny("LIB_BOOT", ["libraryBootstrap","libBootstrap"], {});
      try{ setPersistBootstrap(data); }catch(_e2){}
    }catch(e){
      // If backend is slow/unreachable, stay with persisted data.
      console.warn("Library bootstrap failed:", e);
      try{
        const now = Date.now();
        if(!S.req.lastErrToast || (now - S.req.lastErrToast) > 15000){
          S.req.lastErrToast = now;
          const a = getApp();
          const msg = String(e && (e.message||e) || "Error");
          if(a && a.toast) a.toast("err", "Library sync failed: " + msg);
        }
      }catch(_e3){}
      data = data || (getPersistBootstrap() ? getPersistBootstrap().data : null) || {};
    }
    S.cats = data.cats || [];
    S.myGroups = data.myGroups || [];
    S.canAdmin = !!data.canAdmin;
    S.canMod = !!data.canMod;

    try{
      if(S.canAdmin){
        const inp = $("#slbLibSsId");
        if(inp && data.librarySpreadsheetId) inp.value = String(data.librarySpreadsheetId);
      }
    }catch(_e){}

    // admin / mod controls
    const manageBtn = $("#slbLibManage");
    if(manageBtn){
      if(S.canAdmin || S.canMod) show(manageBtn); else hide(manageBtn);
    }

    // access groups field (for restricted posts)
    if(S.canAdmin || S.canMod){
      show($("#slbLibAccessWrap"));
    }else{
      hide($("#slbLibAccessWrap"));
    }

    // notify toggle (admin/mod only)
    const nwrap = $("#slbLibNotifyWrap");
    if(nwrap){
      if(S.canAdmin || S.canMod) show(nwrap); else hide(nwrap);
      try{ if(!(S.canAdmin || S.canMod)) $("#slbLibNotifyAll").checked = false; }catch(_e){}
    }

    // keep bootstrap groups cached for admin panel (admin/mod)
    S._bootstrapAllGroups = data.allGroups || null;

    // always hide admin panel unless explicitly opened
    hide($("#slbLibAdminBox"));

    // If user was in admin mode, stay there and refresh tools.
    if(S.adminMode){
      enterAdminMode();
      return;
    }

    // Default to list view
    const firstLoad = !S.booted;
    // If selected cat no longer exists, reset.
    try{
      if(S.activeCat && !(S.cats||[]).some(c => String(c.catId||"") === String(S.activeCat||""))){
        S.activeCat = "";
      }
    }catch(_e){}

    if(firstLoad){
      try{ $("#slbLibSearch").value = ""; }catch(_e){}
      // Default to Announcements tab on entry (fallback to first category)
      S.activeCat = pickDefaultCatId_();
      _libEnableSearch(!!S.activeCat);
    }

    setView("list");

    // Load the active category list (cache-first, then network)
    if(S.activeCat){
      await reloadListOnly({useCache:true});
    }

    // Background preload + quiet sync (snappy tabs)
    _libPreloadAllPosts(false).catch(()=>{});
    _libStartBgSync();

    S.booted = true;

    // If we were opened with a deep link, open the post after boot.
    try{ _libMaybeOpenFromHash_(); }catch(_e){}

  }

  function showAdminTools(allGroupsMaybe){

    // Admin-only blocks
    if(!S.canAdmin){
      hide($("#slbLibAdminStorage"));
      hide($("#slbLibAdminDedupe"));
      const del = $("#slbLibGroupDelete");
      if(del) del.disabled = true;
    }else{
      show($("#slbLibAdminStorage"));
      show($("#slbLibAdminDedupe"));
      const del = $("#slbLibGroupDelete");
      if(del) del.disabled = false;
    }
    // categories admin list
    renderCatsAdmin();

    // groups admin
    if(allGroupsMaybe){
      renderGroupsAdmin(allGroupsMaybe);
    }else{
      // fetch on demand
      refreshGroupsAdmin();
    }
  }

  async function refreshGroupsAdmin(){
    try{
      const gg = await rpc("adminLibraryGroupsGet", {});
      renderGroupsAdmin(gg.groups || []);
    }catch(e){
      const msg = $("#slbLibAdminMsg");
      if(msg){ msg.textContent = String(e.message||e); show(msg); }
    }
  }

  function renderGroupsAdmin(groups){
    const sel = $("#slbLibGroupSel");
    if(!sel) return;
    const cur = sel.value;
    sel.innerHTML = "";
    groups.forEach(g => {
      const opt = document.createElement("option");
      opt.value = g.groupKey;
      opt.textContent = g.groupKey;
      sel.appendChild(opt);
    });
    if(cur) sel.value = cur;
    if(!sel.value && groups[0]) sel.value = groups[0].groupKey;

    const membersBox = $("#slbLibGroupMembers");
    const pick = groups.find(x => x.groupKey === sel.value);
    if(membersBox) membersBox.value = pick ? (pick.members || "") : "";

    sel.onchange = () => {
      const p = groups.find(x => x.groupKey === sel.value);
      if(membersBox) membersBox.value = p ? (p.members || "") : "";
    };

    // keep cached
    S._adminGroups = groups;
  }

  function renderCatsAdmin(){
    const wrap = $("#slbLibCatsAdmin");
    if(!wrap) return;
    wrap.innerHTML = "";
    (S.cats||[]).forEach(cat => {
      const row = document.createElement("div");
      row.className = "slbLibPostCard";
      row.style.margin = "8px 0";
      row.innerHTML = `
        <div class="slbLibMeta">catId: ${esc(cat.catId)}</div>
        <div class="row">
          <div class="col">
            <label>Name</label>
            <input class="inp" value="${esc(cat.name||"")}" data-cat-name="${esc(cat.catId)}"/>
          </div>
          <div class="col">
            <label>Sort</label>
            <input class="inp" value="${esc(cat.sort||0)}" data-cat-sort="${esc(cat.catId)}"/>
          </div>
        </div>
        <label>Access Groups</label>
        <input class="inp" value="${esc(cat.accessGroups||"")}" data-cat-groups="${esc(cat.catId)}"/>
        <div class="slbLibTop" style="margin-top:8px;">
          <button class="btn orange" data-cat-save="${esc(cat.catId)}" type="button">Save</button>
          ${S.canAdmin ? ("<button class=\"btn\" data-cat-del=\"" + esc(cat.catId) + "\" type=\"button\">Delete</button>") : ""}
        </div>
      `;
      wrap.appendChild(row);
    });

    $$("[data-cat-save]", wrap).forEach(btn => {
      btn.addEventListener("click", async () => {
        const id = btn.getAttribute("data-cat-save");
        const name = $(`[data-cat-name="${CSS_ESCAPE(id)}"]`, wrap).value;
        const sort = $(`[data-cat-sort="${CSS_ESCAPE(id)}"]`, wrap).value;
        const groups = $(`[data-cat-groups="${CSS_ESCAPE(id)}"]`, wrap).value;
        try{
          const out = await rpc("adminLibraryCatsUpsert", { catId:id, name, sort:Number(sort||0), accessGroups:groups });
          S.cats = out.cats || S.cats;
          renderCats();
          renderCatsAdmin();
        }catch(e){
          const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = String(e.message||e); show(msg); }
        }
      });
    });
    $$("[data-cat-del]", wrap).forEach(btn => {
      btn.addEventListener("click", async () => {
        const id = btn.getAttribute("data-cat-del");
        if(!confirm("Delete this category? (Existing posts will remain but may become harder to find.)")) return;
        try{
          await rpc("adminLibraryCatsDelete", { catId:id });
          // reload everything to refresh cats
          await reload();
          renderCatsAdmin();
        }catch(e){
          const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = String(e.message||e); show(msg); }
        }
      });
    });
  }

  async function addCategory(){
    const btn = $("#slbLibCatAdd");
    if(btn) btn.disabled = true;
    const name = ($("#slbLibCatNameNew").value || "").trim();
    const groups = ($("#slbLibCatGroupsNew").value || "").trim();
    if(!name){ if(btn) btn.disabled = false; return; }
    try{
      const out = await rpc("adminLibraryCatsUpsert", { name, accessGroups: groups, sort: 100 });
      $("#slbLibCatNameNew").value = "";
      $("#slbLibCatGroupsNew").value = "";
      S.cats = out.cats || S.cats;
      renderCats();
      renderCatsAdmin();
    }catch(e){
      const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = String(e.message||e); show(msg); }
    }finally{
      if(btn) btn.disabled = false;
    }
  }

  async function saveGroup(){
    const btn = $("#slbLibGroupSave");
    if(btn) btn.disabled = true;
    const sel = $("#slbLibGroupSel");
    const members = ($("#slbLibGroupMembers").value || "").trim();
    const newKey = ($("#slbLibGroupKeyNew").value || "").trim();
    const groupKey = (newKey || (sel ? sel.value : "")).trim();
    if(!groupKey) return;
    try{
      const out = await rpc("adminLibraryGroupsUpsert", { groupKey, members });
      $("#slbLibGroupKeyNew").value = "";
      renderGroupsAdmin(out.groups || []);
      // refresh bootstrap (so access works for current user if admin modifies groups)
      await reload();
    }catch(e){
      const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = String(e.message||e); show(msg); }
    }finally{
      if(btn) btn.disabled = false;
    }
  }

  async function deleteGroup(){
    if(!S.canAdmin){
      const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = "Admin only."; show(msg); }
      return;
    }
    const sel = $("#slbLibGroupSel");
    const groupKey = sel ? sel.value : "";
    if(!groupKey) return;
    if(!confirm("Delete this group?")) return;
    try{
      const out = await rpc("adminLibraryGroupsDelete", { groupKey });
      await refreshGroupsAdmin();
      await reload();
    }catch(e){
      const msg = $("#slbLibAdminMsg"); if(msg){ msg.textContent = String(e.message||e); show(msg); }
    }
  }

  function bindOnce(){
    const p = panel();
    if(!p || p.__slbLibBound) return;
    p.__slbLibBound = true;

    const catsWrap = $("#slbLibCats");
    if(catsWrap){
      catsWrap.addEventListener("click", (ev) => {
        const btn = ev.target.closest("button.chip");
        if(!btn) return;
        const nextCat = btn.dataset.catId || "";
        if(String(nextCat||"") === String(S.activeCat||"")) return;
        S.activeCat = nextCat;
        S.selectedPostId = "";
        S.page = 1;

        // Seed list from the preloaded all-posts cache for instant first paint.
        try{ const q = ($("#slbLibSearch").value || "").trim(); _libSeedListFromAll(S.activeCat, q);
        try{ S.page = 1; }catch(_e){} }catch(_e){}

        // Instant UI: chip highlight + clear detail
        hide($("#slbLibDetail"));
        setView("list");
        $$("button.chip", catsWrap).forEach(b => b.classList.toggle("on", (b.dataset.catId||"") === (S.activeCat||"")));

        // Keep UI stable: show cached content immediately (stale is OK). Only show Loading if nothing is cached at all.
        try{
          const q = ($("#slbLibSearch").value || "").trim();
          const hitAny = getListCache(S.activeCat, q) || getPersistList(S.activeCat, q);
      if(!hitAny){
        // Try offline read-cache before showing Loading…
        const ok = applyOfflineListIfAny(S.activeCat, q);
        if(!ok){
          const list = $("#slbLibList");
          if(list) list.innerHTML = '<div class="note">Loading…</div>';
        }
      }
}catch(_e){}

        // Fire and forget (prevents the UI from waiting on network)
        reloadListOnly().catch(()=>{});
      });
    }

    const list = $("#slbLibList");
    if(list){
      list.addEventListener("click", (ev) => {
        const card = ev.target.closest(".slbLibPostCard");
        if(!card) return;
        const pid = card.dataset.postId;
        if(!pid) return;
        S.selectedPostId = pid;
        try{ const a = getApp(); if(a && a.toast) a.toast('ok','Opening…'); }catch(_e){}
        openPost(pid).catch(()=>{});
      });
      // Warm detail cache on hover/touch so opening feels instant.
      list.addEventListener("mouseover", (ev) => {
        try{
          const card = ev.target.closest(".slbLibPostCard");
          if(!card) return;
          const pid = card.dataset.postId;
          if(!pid) return;
          _libWarmOneDetail(pid);
        }catch(_e){}
      });
      list.addEventListener("touchstart", (ev) => {
        try{
          const card = ev.target.closest(".slbLibPostCard");
          if(!card) return;
          const pid = card.dataset.postId;
          if(!pid) return;
          _libWarmOneDetail(pid);
        }catch(_e){}
      }, { passive:true });

    }

    const pager = $("#slbLibPager");
    if(pager){
      pager.addEventListener("click", (ev) => {
        const btn = ev.target.closest('button[data-page]');
        if(!btn) return;
        const dir = btn.getAttribute('data-page');
        const all = (S.posts||[]);
        const pageSize = Math.max(1, Number(S.pageSize||15));
        const totalPages = Math.max(1, Math.ceil(all.length / pageSize));
        if(dir === 'prev') S.page = Math.max(1, Number(S.page||1) - 1);
        if(dir === 'next') S.page = Math.min(totalPages, Number(S.page||1) + 1);
        renderList();
        try{ const h = $("#slbLibListHeader"); if(h) h.scrollIntoView({block:'start'}); }catch(_e){}
      });
    }


    const refreshBtn = $("#slbLibRefresh");
    if(refreshBtn) refreshBtn.addEventListener("click", async () => {
      // Quiet refresh: keep current tab selection
      await _libPreloadAllPosts(true);
      if(S.activeCat){ await reloadListOnly({useCache:true}); }
      else{ renderCats(); }
    });

    const search = $("#slbLibSearch");
    if(search){
      let t=null;
      search.addEventListener("input", () => {
        clearTimeout(t);
        t=setTimeout(()=>{ if(!S.activeCat) return; try{ S.page = 1; }catch(_e){} reloadListOnly().catch(()=>{}); }, 250);
      });
      search.addEventListener("keydown", (e) => {
        if(e.key==="Enter"){ e.preventDefault(); if(!S.activeCat) return; reloadListOnly().catch(()=>{}); }
      });
    }


    const sortSel = $("#slbLibSort");
    if(sortSel){
      try{
        const m = _libGetSortMode_();
        sortSel.value = m;
        _libSetSortMode_(m);
      }catch(_e){}
      sortSel.addEventListener("change", () => {
        try{
          _libSetSortMode_(sortSel.value);
          S.page = 1;
          renderList();
        }catch(_e2){}
      });
    }

    const newBtn = $("#slbLibNew");
    if(newBtn) newBtn.addEventListener("click", () => startNew());

    // Manage (Admin / Moderator) -> open Library Admin tools
    const manageBtn = $("#slbLibManage");
    if(manageBtn) manageBtn.addEventListener("click", () => enterAdminMode());

    // Admin tools back -> return to list
    const adminBackBtn = $("#slbLibAdminBackBtn");
    if(adminBackBtn) adminBackBtn.addEventListener("click", () => exitAdminMode());

    const cancelBtn = $("#slbLibCancelBtn");
    if(cancelBtn) cancelBtn.addEventListener("click", () => hide($("#slbLibComposer")));

    const postBtn = $("#slbLibPostBtn");
    if(postBtn) postBtn.addEventListener("click", () => submitPost());

    // Global editor (Standard Editor V1) for Library composer
    try{
      const root = $("#slbLibStdEditor") || ($("#slbLibComposer") ? $("#slbLibComposer").querySelector('[data-slbeditor=\"v1\"]') : null);
      if(root && window.SLB_STD_EDITOR_V1 && typeof window.SLB_STD_EDITOR_V1.bind === 'function'){
        window.SLB_STD_EDITOR_V1.bind(root);
      }
    }catch(_e){}

// admin tools
    const catAdd = $("#slbLibCatAdd");
    if(catAdd) catAdd.addEventListener("click", () => addCategory());

    const grpRef = $("#slbLibGroupRefresh");
    if(grpRef) grpRef.addEventListener("click", () => refreshGroupsAdmin());

    const grpSave = $("#slbLibGroupSave");
    if(grpSave) grpSave.addEventListener("click", () => saveGroup());

    const grpDel = $("#slbLibGroupDelete");
    if(grpDel) grpDel.addEventListener("click", () => deleteGroup());

// admin: spreadsheet id
const ssSave = $("#slbLibSsIdSave");
if(ssSave){
  ssSave.addEventListener("click", async () => {
    const id = ($("#slbLibSsId").value || "").trim();
    const msg = $("#slbLibSsIdMsg");
    if(msg) msg.textContent = "Saving...";
    try{
      const out = await rpcAny("LIB_SET_SS", ["adminSetLibrarySpreadsheetId","adminSetLibrarySpreadsheetId_"], { spreadsheetId: id });
      if(msg) msg.textContent = "Saved. Now using: " + String(out.spreadsheetId || id || "");
      // refresh after changing storage
      await reload();
    }catch(e){
      if(msg) msg.textContent = String(e.message || e);
    }
  });
}

// admin: dedupe categories
const dd = $("#slbLibDedupeBtn");
if(dd){
  dd.addEventListener("click", async () => {
    if(!confirm("Deduplicate Library categories now?\n\nThis will merge common duplicates (e.g. 'General x11') back into the main category, and re-point posts to the canonical IDs.")) return;
    const msg = $("#slbLibDedupeMsg");
    if(msg) msg.textContent = "Working...";
    try{
      const out = await rpc("adminLibraryDedupe", {});
      if(out && out.cats) S.cats = out.cats;
      renderCats();
      renderCatsAdmin();
      if(out && out.groups) renderGroupsAdmin(out.groups);
      await reloadListOnly();
      const moved = out && out.stats && out.stats.postsMoved != null ? out.stats.postsMoved : "";
      const merged = out && out.stats && out.stats.catsMerged != null ? out.stats.catsMerged : "";
      if(msg) msg.textContent = "Done. catsMerged=" + merged + ", postsMoved=" + moved;
    }catch(e){
      if(msg) msg.textContent = String(e.message || e);
    }
  });
}
  }

  function install(){
    bindOnce();
    try{
      const p = panel();
      if(p && !S._bgSyncVisibilityObserver && window.MutationObserver){
        S._bgSyncVisibilityObserver = new MutationObserver(function(){
          if(p.classList.contains('hidden')) _libStopBgSync();
          else if(S.booted) _libStartBgSync();
        });
        S._bgSyncVisibilityObserver.observe(p,{attributes:true,attributeFilter:['class','hidden']});
      }
    }catch(_eBgObs){}
    if(!window.SLB_LIBRARY) window.SLB_LIBRARY = {};
    window.SLB_LIBRARY.reload = async function(){
      const p = panel();
      if(!p) return;
      // On cold loads, the router may not have shown the Library panel yet (waiting for token/session).
      // If we return early here, deep links never open. So: retry a few times until visible.
      if(p.classList.contains("hidden")){
        try{
          const h = String(location.hash||"").toLowerCase();
          if(h.includes("tab=library") || h.includes("#library") || (h.includes("tab=mycabin") && h.includes("cabin=library"))){
            S._visRetry = (S._visRetry||0) + 1;
            if(S._visRetry <= 12){
              setTimeout(()=>{ try{ window.SLB_LIBRARY.reload(); }catch(_e){} }, 200);
            }else{
              S._visRetry = 0;
            }
          }
        }catch(_e){}
        return;
      }
      S._visRetry = 0;
      try{
        await reload();
      }catch(e){
        const list = $("#slbLibList");
        if(list) list.innerHTML = `<div class="err">${esc(e.message||e)}</div>`;
      }
    
    // Go back to Library front page (list) and clear any remembered postId.
    window.SLB_LIBRARY.goHome = function(){
      try{ window.__SLB_LIB_SELECTED_POSTID = ""; }catch(_e){}
      try{ S.selectedPostId = ""; }catch(_e){}
      try{ setView("list"); }catch(_e){}
      try{
        if(history && history.replaceState) history.replaceState(null, "", "#tab=myCabin&cabin=library");
        else location.hash = "#tab=myCabin&cabin=library";
      }catch(_e){}
      try{ renderList(); }catch(_e){}
    };
};
  }

  // Boot
  install();

  // Deep link open on cold load / refresh:
  // hashchange does NOT fire on first load, and reload() may run more than once.
  // This ensures the selected post opens reliably even on F5 refresh.
  function _libDeepLinkEnter_(pid){
    pid = String(pid||"").trim();
    if(!pid) return false;
    try{ S.selectedPostId = pid; }catch(_e){}
    try{ window.__SLB_LIB_SELECTED_POSTID = pid; }catch(_e2){}
    try{ setView("thread"); }catch(_e3){}
    // Best-effort token hydration (if core hasn't done it yet)
    try{
      const a = getApp && getApp();
      const SS = a && a.S ? a.S : (window.SLB_APP && SLB_APP.S ? SLB_APP.S : null);
      if(SS && !SS.token){
        const t1 = sessionStorage.getItem("tyw_token") || "";
        let t2 = "";
        try{ t2 = JSON.parse(localStorage.getItem("ty_auth_v1")||"{}").token || ""; }catch(_e){}
        const tok = t1 || t2;
        if(tok){ SS.token = tok; try{ sessionStorage.setItem("tyw_token", tok); }catch(_e2){} }
      }
    }catch(_e){}
    try{ openPost(pid).catch(()=>{}); }catch(_e){}
    return true;
  }

  function _libTryDeepLinkOnLoad_(){
    try{
      const pid = _libHashPostId_();
      if(!pid) return false;
      const p = panel();
      const box = $("#slbLibDetail");
      if(!p || !box) return false;
      // Wait until the panel is visible (router might reveal it slightly later)
      if(p.classList.contains("hidden")) return false;
      return _libDeepLinkEnter_(pid);
    }catch(_e){}
    return false;
  }

  // If already on library tab, load shortly (and also handle deep links).
  setTimeout(() => {
    try{
      const h = String(location.hash||"").toLowerCase();
      if(!(h.includes("library") || h.includes("tab=library"))) return;
      // First: try to open deep-linked post immediately (works on F5 refresh)
      if(_libTryDeepLinkOnLoad_()){
        // Also bootstrap in the background (cats/permissions/list caches)
        try{ window.SLB_LIBRARY.reload(); }catch(_e){}
        return;
      }
      // Otherwise normal load
      window.SLB_LIBRARY.reload();
    }catch(_e){}
  }, 250);

})(); 

